import React, { useState, useEffect, useRef } from 'react';
import { API_BASE_URL } from '../../config';
import { useAuth } from '../../context/auth/AuthContext';

const PhoneNumbers = () => {
  const { userId } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [expanded, setExpanded] = useState(new Set()); // Use Set to track all expanded accordion items
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [inboundAgents, setInboundAgents] = useState([]);
  const [outboundAgents, setOutboundAgents] = useState([]);
  const [availableAgents, setAvailableAgents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showAgentModal, setShowAgentModal] = useState(false);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState(null);
  const [agentType, setAgentType] = useState(''); // 'inbound' or 'outbound'
  const [isConnecting, setIsConnecting] = useState(false);
  const [outboundCallLoading, setOutboundCallLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState({});
  const [agentSelectionLoading, setAgentSelectionLoading] = useState(false);
  const [selectedAgentForUpdate, setSelectedAgentForUpdate] = useState(null);
  
  // State for phone numbers JSON display and transfer functionality
  // const [showPhoneNumbersJsonModal, setShowPhoneNumbersJsonModal] = useState(false);
  // const [agentPhoneNumbersJson, setAgentPhoneNumbersJson] = useState(null);
  const [transferToNumber, setTransferToNumber] = useState('');
  
  // Transfer Call Configuration Modal State
  const [showTransferCallModal, setShowTransferCallModal] = useState(false);
  const [transferCallConfig, setTransferCallConfig] = useState({
    name: 'transfer_call',
    description: 'Transfer the call to a human agent.',
    transfer_to: 'static', // static, dynamic
    destination_number: '',
    transfer_type: 'cold', // cold, warm
    displayed_phone_number: 'retell_agent', // retell_agent, transferee
    custom_sip_headers: []
  });
  const [transferCallResult, setTransferCallResult] = useState(null);
  const [showTransferResult, setShowTransferResult] = useState(false);
  
  // Webhook Configuration Modal State
  const [showWebhookModal, setShowWebhookModal] = useState(false);
  const [showWebhookJsonDisplay, setShowWebhookJsonDisplay] = useState(false);
  const [selectedPhoneForWebhook, setSelectedPhoneForWebhook] = useState(null);
  const [webhookConfig, setWebhookConfig] = useState({
    user_phone_number: '', // Will be populated from agent config
    agent_id: '',
    notification_phone: '',
    verification_list: [], // Will be populated from agent config
    webhook_url: '',
    post_call_webhook_url: ''
  });
  const [webhookResult, setWebhookResult] = useState(null);
  const [showWebhookResult, setShowWebhookResult] = useState(false);
  
  // Form state for the modal
  const [formData, setFormData] = useState({
    phoneNumber: '',
    terminationUri: '',
    sipTrunkUserName: '',
    sipTrunkPassword: '',
    nickname: ''
  });


  // Nested Dropdown Component
  const NestedAgentDropdown = ({ 
    value, 
    onChange, 
    agents, 
    placeholder = "Select an agent",
    style = {}
  }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [hoveredAgent, setHoveredAgent] = useState(null);
    const [hoverTimeout, setHoverTimeout] = useState(null);
    const dropdownRef = useRef(null);

                   // Check if agents is already grouped (object) or needs grouping (array)
      const groupedAgents = typeof agents === 'object' && !Array.isArray(agents) 
        ? agents 
        : agents.reduce((groups, agent) => {
            const baseName = agent.base_name || agent.agent_name;
            if (!groups[baseName]) {
              groups[baseName] = {
                base_name: baseName,
                original_agent: null,
                versions: []
              };
            }
            
            // If agent has version info, add to versions
            if (agent.is_version || agent.version || (agent.agent_name && agent.agent_name.includes(' - '))) {
              groups[baseName].versions.push(agent);
            } else {
              // Otherwise, treat as original agent
              groups[baseName].original_agent = agent;
            }
            
            return groups;
          }, {});
     
                  // Debug: Log the grouped agents in the dropdown
       console.log('=== NESTED DROPDOWN RENDER ===');
       console.log('NestedAgentDropdown groupedAgents:', groupedAgents);
       console.log('Current hoveredAgent:', hoveredAgent);
       console.log('Current value:', value);
       console.log('Number of groups:', Object.keys(groupedAgents).length);
      
      // Log each group's details
      Object.values(groupedAgents).forEach(group => {
        console.log(`Group ${group.base_name}:`, {
          original_agent: group.original_agent?.agent_name,
          original_agent_id: group.original_agent?.agent_id,
          versions_count: group.versions.length,
          versions: group.versions.map(v => ({ agent_name: v.agent_name, agent_id: v.agent_id, version: v.version }))
        });
      });

    // Flatten agents for finding by ID
    const allAgents = [];
    Object.values(groupedAgents).forEach(group => {
      if (group.original_agent) {
        allAgents.push(group.original_agent);
      }
      group.versions.forEach(version => {
        allAgents.push(version);
      });
    });

                   // Get display value
      const getDisplayValue = () => {
        if (!value || value === 'No agents available') return placeholder;
        
        // First try to find by agent_id
        let agent = allAgents.find(a => a.agent_id === value);
        
        // If not found by agent_id, try to find by agent_name (for backward compatibility)
        if (!agent) {
          agent = allAgents.find(a => a.agent_name === value);
        }
        
        if (!agent) {
          console.log('Agent not found for value:', value, 'Available agents:', allAgents.map(a => ({ id: a.agent_id, name: a.agent_name })));
          return placeholder;
        }
        
        // Return the full agent name as it appears in the API
        return agent.agent_name;
      };

    // Handle agent selection
    const handleAgentSelect = (agent) => {
      onChange(agent.agent_id);
      setIsOpen(false);
      setHoveredAgent(null);
    };

                   // Handle original agent selection
      const handleOriginalAgentSelect = (group) => {
        if (group.versions && group.versions.length > 0) {
          // If has versions, show submenu
          setHoveredAgent(group.base_name);
        } else if (group.original_agent) {
          // If no versions, select the original agent
          onChange(group.original_agent.agent_id);
          setIsOpen(false);
          setHoveredAgent(null);
        }
      };

    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
          setHoveredAgent(null);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        // Clean up any existing timeout
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }
      };
    }, [hoverTimeout]);

    return (
      <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
        {/* Main Input */}
        <div
          onClick={() => setIsOpen(!isOpen)}
          style={{
            width: '100%',
            padding: '14px 18px',
            borderRadius: 12,
            border: '1px solid #e5e7eb',
            fontSize: '1.05rem',
            background: '#fafbfc',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            ...style
          }}
        >
          <span style={{ color: value && value !== 'No agents available' ? '#111827' : '#6b7280' }}>
            {getDisplayValue()}
          </span>
          <i className={`fas fa-chevron-${isOpen ? 'up' : 'down'}`} style={{ color: '#6b7280' }}></i>
        </div>

        {/* Dropdown Menu */}
        {isOpen && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: '#fff',
            border: '1px solid #e5e7eb',
            borderRadius: 8,
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
            zIndex: 1000,
            maxHeight: '300px',
            overflowY: 'auto'
          }}>
            

            {/* No agents message */}
            {Object.keys(groupedAgents).length === 0 && (
              <div style={{
                padding: '12px 16px',
                color: '#6b7280',
                fontStyle: 'italic',
                borderBottom: '1px solid #f3f4f6'
              }}>
                No agents available for this user
              </div>
            )}

            {/* Agent Groups */}
            {Object.values(groupedAgents).map((group, index) => (
              <div key={group.base_name} style={{ position: 'relative' }}>
                {/* Main Agent Option */}
                <div
                  onClick={() => handleOriginalAgentSelect(group)}
                  style={{
                    padding: '12px 16px',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f3f4f6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    backgroundColor: hoveredAgent === group.base_name ? '#f3f4f6' : '#fff'
                  }}
                  onMouseEnter={(e) => {
                    e.target.parentElement.style.backgroundColor = '#f3f4f6';
                    // Clear any existing timeout
                    if (hoverTimeout) {
                      clearTimeout(hoverTimeout);
                    }
                    setHoveredAgent(group.base_name);
                  }}
                  onMouseLeave={(e) => {
                    e.target.parentElement.style.backgroundColor = '#fff';
                    // Add a small delay before hiding the submenu
                    const timeout = setTimeout(() => {
                      setHoveredAgent(null);
                    }, 150);
                    setHoverTimeout(timeout);
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontWeight: '500' }}>{group.base_name}</span>
                    {group.versions.length > 0 && (
                      <span style={{
                        background: '#e0e7ff',
                        color: '#3730a3',
                        padding: '2px 6px',
                        borderRadius: '4px',
                        fontSize: '0.7rem',
                        fontWeight: '500'
                      }}>
                        {group.versions.length} version{group.versions.length !== 1 ? 's' : ''}
                      </span>
                    )}
                  </div>
                                     {group.versions.length > 0 && (
                     <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                       <span style={{ fontSize: '0.7rem', color: '#6b7280' }}>
                         Hover for versions
                       </span>
                       <i className="fas fa-chevron-right" style={{ color: '#6b7280', fontSize: '12px' }}></i>
                     </div>
                   )}
                </div>

                                                                                                                                       {/* Sub-menu for versions */}
                {hoveredAgent === group.base_name && group.versions.length > 0 && (
                  <div 
                    style={{
                      position: 'absolute',
                      left: '100%',
                      top: 0,
                      background: '#fff',
                      border: '1px solid #e5e7eb',
                      borderRadius: 8,
                      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                      minWidth: '250px',
                      zIndex: 1001,
                      maxHeight: '300px',
                      overflowY: 'auto'
                    }}
                    onMouseEnter={() => {
                      // Clear any existing timeout when hovering over submenu
                      if (hoverTimeout) {
                        clearTimeout(hoverTimeout);
                      }
                    }}
                    onMouseLeave={() => {
                      // Add a small delay before hiding the submenu
                      const timeout = setTimeout(() => {
                        setHoveredAgent(null);
                      }, 150);
                      setHoverTimeout(timeout);
                    }}
                  >
                    {/* Header for versions */}
                    <div style={{
                      padding: '8px 16px',
                      background: '#f8fafc',
                      borderBottom: '1px solid #e5e7eb',
                      fontWeight: '600',
                      fontSize: '0.875rem',
                      color: '#374151'
                    }}>
                      Versions of {group.base_name}
                    </div>
                    
                    {/* Original agent option in submenu */}
                    {group.original_agent && (
                      <div
                        onClick={() => handleAgentSelect(group.original_agent)}
                        style={{
                          padding: '12px 16px',
                          cursor: 'pointer',
                          borderBottom: '1px solid #f3f4f6',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                      >
                        <div>
                          <div style={{ fontWeight: '500', color: '#111827' }}>
                            {group.original_agent.agent_name}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '2px' }}>
                            Original Version
                          </div>
                        </div>
                        <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                          ID: {group.original_agent.agent_id}
                        </span>
                      </div>
                    )}
                    
                    {/* Version options */}
                    {group.versions.map((version, versionIndex) => (
                      <div
                        key={version.agent_id}
                        onClick={() => handleAgentSelect(version)}
                        style={{
                          padding: '12px 16px',
                          cursor: 'pointer',
                          borderBottom: versionIndex === group.versions.length - 1 ? 'none' : '1px solid #f3f4f6',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#f9fafb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                      >
                        <div>
                          <div style={{ fontWeight: '500', color: '#111827' }}>
                            {version.agent_name}
                          </div>
                          <div style={{ fontSize: '0.75rem', color: '#6b7280', marginTop: '2px' }}>
                            Version {version.version || versionIndex + 1}
                          </div>
                        </div>
                        <span style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                          ID: {version.agent_id}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            
          </div>
        )}
      </div>
    );
  };

  // Get user email from localStorage or session
  const getUserEmail = () => {
    // In a real app, you'd get this from your auth context or session
    return localStorage.getItem('userEmail') || '';
  };

  // Debug webhook config changes
  useEffect(() => {
    console.log('🔄 webhookConfig changed:', webhookConfig);
  }, [webhookConfig]);

  // Validate user authentication and get user details
  const validateUserAuthentication = async () => {
    try {
      console.log('🔐 ===== USER AUTHENTICATION VALIDATION =====');
      console.log('🔐 Checking user authentication for userId:', userId);
      
      if (!userId) {
        console.log('🔐 No userId found in auth context');
        setError('❌ User authentication required. Please log in to access phone numbers.');
        setLoading(false);
        return false;
      }

      // Validate user_id format and type
      if (typeof userId !== 'string' || userId.trim().length === 0) {
        console.log('🔐 Invalid userId format:', userId);
        setError('❌ Invalid user authentication. Please log in again.');
        setLoading(false);
        return false;
      }

      console.log('🔐 User authentication validated successfully');
      console.log('🔐 User ID:', userId);
      console.log('🔐 User ID type:', typeof userId);
      console.log('🔐 User ID length:', userId.length);
      console.log('🔐 ===== END USER VALIDATION =====');
      
      return true;
    } catch (error) {
      console.error('🔐 Error validating user authentication:', error);
      setError('❌ Authentication validation failed. Please refresh the page and log in again.');
      setLoading(false);
      return false;
    }
  };

  // Fetch phone numbers from API filtered by user_id
  const fetchPhoneNumbers = async () => {
    try {
      setLoading(true);
      setError(''); // Clear any previous errors
      setSuccess(''); // Clear any previous success messages
      
      console.log('📞 ===== PHONE NUMBERS FETCH REQUEST =====');
      console.log('📞 Starting phone numbers fetch process...');
      
      // Step 1: Validate user authentication first
      const isUserValid = await validateUserAuthentication();
      if (!isUserValid) {
        console.log('📞 User authentication failed, aborting phone numbers fetch');
        return;
      }
      
      // Step 2: User is authenticated, proceed with fetching phone numbers
      console.log('📞 User authenticated successfully, fetching phone numbers...');
      console.log('📞 Fetching phone numbers for user_id:', userId);
      console.log('📞 API URL:', `${API_BASE_URL}/api/phone-numbers/all?user_id=${encodeURIComponent(userId)}`);
      
      const response = await fetch(`${API_BASE_URL}/api/phone-numbers/all?user_id=${encodeURIComponent(userId)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`, // Add auth header if available
        },
      });
      
      console.log('📞 API Response status:', response.status);
      console.log('📞 API Response headers:', Object.fromEntries(response.headers.entries()));
      
      if (!response.ok) {
        if (response.status === 401) {
          setError('❌ Authentication expired. Please log in again.');
          console.log('📞 Authentication expired, user needs to re-login');
          return;
        } else if (response.status === 403) {
          setError('❌ Access denied. You do not have permission to view phone numbers.');
          console.log('📞 Access denied for user:', userId);
          return;
        } else if (response.status === 404) {
          setError('❌ Phone numbers service not found. Please contact support.');
          console.log('📞 Phone numbers service not found');
          return;
        } else {
          setError(`❌ Server error (${response.status}). Please try again later.`);
          console.log('📞 Server error:', response.status);
          return;
        }
      }
      
      const data = await response.json();
      console.log('📞 API Response data:', data);
      console.log('📞 ===== END PHONE NUMBERS FETCH =====');
      
      if (data.success) {
        const phoneNumbersList = data.phoneNumbers || [];
        console.log('📞 Phone numbers list received:', phoneNumbersList.length, 'numbers');
        
        // Validate phone numbers data structure
        if (Array.isArray(phoneNumbersList)) {
          setPhoneNumbers(phoneNumbersList);
          
          // Fetch agent details for each phone number
          if (phoneNumbersList.length > 0) {
            console.log('📞 Fetching agent details for', phoneNumbersList.length, 'phone numbers');
            await fetchAgentDetailsForPhoneNumbers(phoneNumbersList);
            // Success message removed as requested
          } else {
            // Empty result is NOT an error - user simply has no phone numbers yet
            setInboundAgents([]);
            setOutboundAgents([]);
            setSuccess(`📞 Welcome! You haven't added any phone numbers yet. Click the + button to add your first phone number.`);
            console.log('📞 User has no phone numbers yet - this is normal, not an error');
          }
          
          console.log('✅ Phone numbers loaded successfully for user:', userId, phoneNumbersList.length, 'numbers found');
        } else {
          console.error('📞 Invalid phone numbers data structure:', phoneNumbersList);
          setError('❌ Invalid phone numbers data received from server. Please contact support.');
          setPhoneNumbers([]);
          setInboundAgents([]);
          setOutboundAgents([]);
        }
      } else {
        console.log('📞 API returned unsuccessful response:', data);
        setPhoneNumbers([]);
        setInboundAgents([]);
        setOutboundAgents([]);
        
        if (data.error) {
          setError(`❌ ${data.error}`);
        } else {
          // Even if API returns success: false, if there's no error message, 
          // it might just mean no phone numbers found (which is normal)
          setSuccess(`📞 Welcome! You haven't added any phone numbers yet. Click the + button to add your first phone number.`);
        }
      }
    } catch (error) {
      console.error('❌ Error fetching phone numbers for user:', userId, error);
      
      // Provide specific error messages based on error type
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        setError('❌ Network error. Please check your internet connection and try again.');
      } else if (error.name === 'SyntaxError') {
        setError('❌ Invalid response from server. Please contact support.');
      } else {
        setError(`❌ Failed to load phone numbers for user ${userId}. Please check your connection and try again.`);
      }
      
      setPhoneNumbers([]);
      setInboundAgents([]);
      setOutboundAgents([]);
      setSuccess('');
    } finally {
      setLoading(false);
    }
  };

  // Fetch agents from API filtered by user_id
  const fetchAvailableAgents = async () => {
    try {
      // Validate user authentication first
      const isUserValid = await validateUserAuthentication();
      if (!isUserValid) {
        console.log('🔐 User authentication failed, aborting agents fetch');
        setAvailableAgents([]);
        return;
      }

      console.log('🔍 Fetching agents for user_id:', userId);
      
      // Use the user-specific agents endpoint
      const response = await fetch(`${API_BASE_URL}/api/all-agents?user_id=${encodeURIComponent(userId)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });
      
      console.log('🔍 Agents API Response status:', response.status);
      
      if (!response.ok) {
        if (response.status === 401) {
          console.log('🔍 Authentication expired for agents fetch');
          setAvailableAgents([]);
          return;
        } else if (response.status === 403) {
          console.log('🔍 Access denied for agents fetch');
          setAvailableAgents([]);
          return;
        } else {
          console.log('🔍 Server error for agents fetch:', response.status);
          setAvailableAgents([]);
          return;
        }
      }
      
      const data = await response.json();
      console.log('🔍 Agents API Response data:', data);
      
      if (Array.isArray(data) && data.length > 0) {
        setAvailableAgents(data);
        console.log('✅ Successfully loaded', data.length, 'agents for user:', userId);
      } else {
        console.log('📝 No agents found for user:', userId, '- this is normal if user has not created any agents yet');
        // Set empty array if no agents are available for this user
        setAvailableAgents([]);
      }
    } catch (error) {
      console.error('❌ Error fetching agents for user:', userId, error);
      // Set empty array if there's an error
      setAvailableAgents([]);
    }
  };

  // Fetch agent details for each phone number
  const fetchAgentDetailsForPhoneNumbers = async (phoneNumbersList) => {
    try {
      console.log('🔍 Phone numbers list structure:', phoneNumbersList);
      console.log('🔍 Starting to fetch agent details for phone numbers:', phoneNumbersList.map(p => p.phone_numbers));
      
      const agentDetailsPromises = phoneNumbersList.map(async (phoneNumber) => {
        // Use the correct property - should be phone_numbers
        const phoneNumberValue = phoneNumber.phone_numbers || phoneNumber.id;
        
        try {
          console.log(`🔍 Phone number object:`, phoneNumber);
          console.log(`🔍 Available properties:`, Object.keys(phoneNumber));
          console.log(`🔍 phone_numbers property:`, phoneNumber.phone_numbers);
          console.log(`🔍 id property:`, phoneNumber.id);
          console.log(`🔍 Fetching agent details for phone number: ${phoneNumber.phone_numbers}`);
          console.log(`🔍 API URL: ${API_BASE_URL}/api/phone-numbers/${phoneNumber.phone_numbers}/agents`);
          console.log(`🔍 Using phone number value: ${phoneNumberValue}`);
          
          const response = await fetch(`${API_BASE_URL}/api/phone-numbers/${phoneNumberValue}/agents`);
          console.log(`🔍 Response status: ${response.status}`);
          
          const data = await response.json();
          console.log(`🔍 Response for ${phoneNumber.phone_numbers}:`, data);
          
          if (data.success) {
            return {
              phoneNumberId: phoneNumberValue,
              inboundAgent: data.inboundAgent.agent_name,
              outboundAgent: data.outboundAgent.agent_name
            };
          } else {
            console.error(`Failed to fetch agent details for ${phoneNumberValue}:`, data.error);
            return {
              phoneNumberId: phoneNumberValue,
              inboundAgent: data.inboundAgent?.agent_name || 'Click "Change Agent" to assign',
              outboundAgent: data.outboundAgent?.agent_name || 'Click "Change Agent" to assign'
            };
          }
        } catch (error) {
          console.error(`Error fetching agent details for ${phoneNumberValue}:`, error);
          return {
            phoneNumberId: phoneNumberValue,
            inboundAgent: 'Click "Change Agent" to assign',
            outboundAgent: 'Click "Change Agent" to assign'
          };
        }
      });

      const agentDetails = await Promise.all(agentDetailsPromises);
      
      // Update the inbound and outbound agents arrays
      const newInboundAgents = phoneNumbersList.map(phoneNumber => {
        const phoneNumberValue = phoneNumber.phone_numbers || phoneNumber.id;
        const details = agentDetails.find(detail => detail.phoneNumberId === phoneNumberValue);
        return details ? details.inboundAgent : 'Click "Change Agent" to assign';
      });
      
      const newOutboundAgents = phoneNumbersList.map(phoneNumber => {
        const phoneNumberValue = phoneNumber.phone_numbers || phoneNumber.id;
        const details = agentDetails.find(detail => detail.phoneNumberId === phoneNumberValue);
        return details ? details.outboundAgent : 'Click "Change Agent" to assign';
      });

      setInboundAgents(newInboundAgents);
      setOutboundAgents(newOutboundAgents);
      
      console.log('✅ Agent details fetched for all phone numbers');
    } catch (error) {
      console.error('Error fetching agent details:', error);
    }
  };

  // Load phone numbers and agents on component mount and when userId changes
  useEffect(() => {
    console.log('🔄 ===== PHONE NUMBERS COMPONENT USEEFFECT =====');
    console.log('🔄 Component mounted or userId changed');
    console.log('🔄 Current userId:', userId);
    console.log('🔄 userId type:', typeof userId);
    console.log('🔄 userId exists:', !!userId);
    
    // Clear previous state when userId changes
    setError('');
    setSuccess('');
    setPhoneNumbers([]);
    setInboundAgents([]);
    setOutboundAgents([]);
    
    if (userId) {
      console.log('🔄 Valid userId found, starting data fetch process...');
      console.log('🔄 PhoneNumbers component loaded for user:', userId);
      
      // Start the data fetching process
      const initializeData = async () => {
        try {
          setLoading(true);
          
          // First validate user authentication
          const isUserValid = await validateUserAuthentication();
          if (!isUserValid) {
            console.log('🔄 User validation failed, stopping initialization');
            return;
          }
          
          // User is valid, fetch phone numbers and agents
          console.log('🔄 User validation successful, fetching data...');
          await Promise.all([
            fetchPhoneNumbers(),
            fetchAvailableAgents()
          ]);
          
          console.log('🔄 Data initialization completed successfully');
        } catch (error) {
          console.error('🔄 Error during data initialization:', error);
          setError('❌ Failed to initialize phone numbers data. Please refresh the page and try again.');
        } finally {
          setLoading(false);
        }
      };
      
      initializeData();
    } else {
      console.log('⚠️ PhoneNumbers component loaded but no userId available');
      setError('❌ User authentication required. Please log in to access phone numbers.');
      setLoading(false);
    }
    
    console.log('🔄 ===== END PHONE NUMBERS COMPONENT USEEFFECT =====');
  }, [userId]);

  // Expand all accordion items by default when phone numbers are loaded
  useEffect(() => {
    if (phoneNumbers.length > 0) {
      const allIndices = new Set(phoneNumbers.map((_, idx) => idx));
      setExpanded(allIndices);
    }
  }, [phoneNumbers.length]); // Only run when the count of phone numbers changes

  const handleAccordionClick = idx => {
    setExpanded(prev => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(idx)) {
        newExpanded.delete(idx);
      } else {
        newExpanded.add(idx);
      }
      return newExpanded;
    });
  };

  const handleInboundChange = async (idx, value) => {
    try {
      const phoneNumber = phoneNumbers[idx];
      const response = await fetch(`${API_BASE_URL}/api/phone-numbers/${phoneNumber.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inboundAgent: value,
          outboundAgent: outboundAgents[idx],
          webhookEnabled: phoneNumber.webhook
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Inbound agent updated successfully:', data);
        setInboundAgents(prev => prev.map((a, i) => (i === idx ? value : a)));
        // Refresh phone numbers to get updated data
        fetchPhoneNumbers();
      } else {
        console.error('Failed to update inbound agent');
      }
    } catch (error) {
      console.error('Error updating inbound agent:', error);
    }
  };

  const handleOutboundChange = async (idx, value) => {
    try {
      const phoneNumber = phoneNumbers[idx];
      const response = await fetch(`${API_BASE_URL}/api/phone-numbers/${phoneNumber.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inboundAgent: inboundAgents[idx],
          outboundAgent: value,
          webhookEnabled: phoneNumber.webhook
        }),
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Outbound agent updated successfully:', data);
        setOutboundAgents(prev => prev.map((a, i) => (i === idx ? value : a)));
        // Refresh phone numbers to get updated data
        fetchPhoneNumbers();
      } else {
        console.error('Failed to update outbound agent');
      }
    } catch (error) {
      console.error('Error updating outbound agent:', error);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleChangeAgent = (phoneNumber, type) => {
    setSelectedPhoneNumber(phoneNumber);
    setAgentType(type);
    setShowAgentModal(true);
  };

  const handleAgentSelection = async (agentName) => {
    try {
      setAgentSelectionLoading(true);
      setSelectedAgentForUpdate(agentName); // Track which agent is being updated
      setError(''); // Clear any previous errors
      setSuccess(''); // Clear any previous success messages
      
      const phoneNumber = selectedPhoneNumber;
      const phoneNumberIndex = phoneNumbers.findIndex(p => p.id === phoneNumber.id);
      
      // Get the current agent assignments
      const currentInboundAgent = agentType === 'inbound' ? agentName : inboundAgents[phoneNumberIndex];
      const currentOutboundAgent = agentType === 'outbound' ? agentName : outboundAgents[phoneNumberIndex];
      
      // Find the agent objects to get their IDs
      const inboundAgentObj = availableAgents.find(agent => agent.agent_name === currentInboundAgent);
      const outboundAgentObj = availableAgents.find(agent => agent.agent_name === currentOutboundAgent);
      
      console.log('🔄 Updating phone number with agent IDs:', {
        phoneNumberId: phoneNumber.id,
        phoneNumber: phoneNumber.phoneNumber || phoneNumber.id,
        currentInboundAgent,
        currentOutboundAgent,
        inboundAgentId: inboundAgentObj?.agent_id,
        outboundAgentId: outboundAgentObj?.agent_id
      });
      
      // Step 1: Update the phone number in the database
      const updateResponse = await fetch(`${API_BASE_URL}/api/phone-numbers/${phoneNumber.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inboundAgent: currentInboundAgent,
          outboundAgent: currentOutboundAgent,
          inboundAgentId: inboundAgentObj?.agent_id,
          outboundAgentId: outboundAgentObj?.agent_id,
          webhookEnabled: phoneNumber.webhook
        }),
      });

      if (!updateResponse.ok) {
        const errorData = await updateResponse.json();
        console.error(`Failed to update ${agentType} agent in database:`, errorData);
        setError(`❌ Failed to update ${agentType} agent in database: ${errorData.error || 'Unknown error'}`);
        setAgentSelectionLoading(false);
        setSelectedAgentForUpdate(null);
        return;
      }

      const updateData = await updateResponse.json();
      console.log(`✅ ${agentType} agent updated successfully in database:`, updateData);

      // Step 2: Update the agent configuration in Retell using the SDK
      const retellUpdateResponse = await fetch(`${API_BASE_URL}/api/retell/update-phone-agents`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phoneNumber: phoneNumber.phoneNumber || phoneNumber.id,
          inboundAgentId: inboundAgentObj?.agent_id,
          outboundAgentId: outboundAgentObj?.agent_id,
          nickname: phoneNumber.nickname,
          // Send the complete phone number data for reference
          phoneNumberData: {
            id: phoneNumber.id,
            phoneNumber: phoneNumber.phoneNumber || phoneNumber.id,
            nickname: phoneNumber.nickname,
            terminationUri: phoneNumber.terminationUri,
            sipTrunkUserName: phoneNumber.sipTrunkUserName,
            sipTrunkPassword: phoneNumber.sipTrunkPassword,
            connectionStatus: phoneNumber.connectionStatus,
            provider: phoneNumber.provider,
            retellData: phoneNumber.retellData,
            created_at: phoneNumber.created_at,
            last_modification_timestamp: phoneNumber.last_modification_timestamp
          }
        }),
      });

      if (retellUpdateResponse.ok) {
        const retellData = await retellUpdateResponse.json();
        console.log(`✅ ${agentType} agent updated successfully in Retell AI:`, retellData);
        
        // Show simple success message
        setSuccess(`✅ Your ${agentType === 'inbound' ? 'inbound' : 'outbound'} agent is being updated successfully for this phone number`);
      } else {
        const retellErrorData = await retellUpdateResponse.json();
        console.error(`Failed to update ${agentType} agent in Retell AI:`, retellErrorData);
        
        // Show simple error message for partial update
        setError(`⚠️ ${agentType === 'inbound' ? 'Inbound' : 'Outbound'} agent was updated in database but failed to update in Retell AI. Please try again.`);
      }
      
      // Update only the specific phone number's agent details instead of refreshing entire page
      updatePhoneNumberAgentDetails(phoneNumber.id, agentName, agentType);
      setShowAgentModal(false);
      setSelectedPhoneNumber(null);
      setAgentType('');
      setAgentSelectionLoading(false);
      setSelectedAgentForUpdate(null);
    } catch (error) {
      console.error(`Error updating ${agentType} agent:`, error);
      setError(`❌ Network error updating ${agentType} agent. Please check your connection and try again.`);
      setAgentSelectionLoading(false);
      setSelectedAgentForUpdate(null);
    }
  };

  // Function to update only the specific phone number's agent details without refreshing entire page
  const updatePhoneNumberAgentDetails = (phoneNumberId, agentName, agentType) => {
    const phoneNumberIndex = phoneNumbers.findIndex(p => p.id === phoneNumberId);
    if (phoneNumberIndex === -1) {
      console.error('Phone number not found for update:', phoneNumberId);
      return;
    }

    // Update the specific agent in the arrays
    if (agentType === 'inbound') {
      setInboundAgents(prev => {
        const newAgents = [...prev];
        newAgents[phoneNumberIndex] = agentName;
        return newAgents;
      });
    } else if (agentType === 'outbound') {
      setOutboundAgents(prev => {
        const newAgents = [...prev];
        newAgents[phoneNumberIndex] = agentName;
        return newAgents;
      });
    }

    console.log(`✅ Updated ${agentType} agent for phone number ${phoneNumberId} to: ${agentName}`);
  };

  // Debug function to check what's in the database
  const debugPhoneNumbers = async () => {
    try {
      console.log('🔍 Debug: Checking phone numbers and agents...');
      const response = await fetch(`${API_BASE_URL}/api/debug/phone-numbers`);
      const data = await response.json();
      
      if (data.success) {
        console.log('🔍 Phone numbers in database:', data.phoneNumbers);
        console.log('🔍 Available agents:', data.availableAgents);
        
        // Test the specific agent ID from the database
        const phoneNumber = data.phoneNumbers.find(p => p.phone_numbers === '+61380072233');
        if (phoneNumber && phoneNumber.inbound_agent_id) {
          console.log('🔍 Testing specific agent ID:', phoneNumber.inbound_agent_id);
          const agentResponse = await fetch(`${API_BASE_URL}/api/test-agent/${phoneNumber.inbound_agent_id}`);
          const agentData = await agentResponse.json();
          console.log('🔍 Agent test result:', agentData);
        }
      } else {
        console.error('🔍 Debug failed:', data.error);
      }
    } catch (error) {
      console.error('🔍 Debug error:', error);
    }
  };

  // Handle Connect Numbers button - dynamic phone number purchase
  const handleConnectNumbers = async () => {
    setSubmitting(true);
    setError('');
    setSuccess('');

    // Check if user ID is available
    if (!userId) {
      setError('User ID is not available. Please refresh the page and try again.');
      setSubmitting(false);
      return;
    }

    try {
      setSuccess('Connecting to Twilio and purchasing phone number...');
      
      // Log the request data for debugging
      console.log('📞 Purchasing Twilio phone number with user ID:', userId);
      
      // Get the first available agent to associate with the phone number (same as CreateAgentForm)
      let defaultAgentId = null;
      if (availableAgents && availableAgents.length > 0) {
        defaultAgentId = availableAgents[0].agent_id;
        console.log('📞 Found available agent for phone number association:', {
          agent_name: availableAgents[0].agent_name,
          agent_id: defaultAgentId
        });
      } else {
        console.log('📞 No available agents found - phone number will be created without agent association');
      }

      
      // Use default values for direct purchase (same as CreateAgentForm)
      const defaultPurchaseData = {
        country: 'AU',
        number_type: 'local',
        area_code: undefined,
        contains: undefined,
        voice_enabled: true,
        sms_enabled: false,
        limit: 10,
        auto_buy_first: true, // Automatically purchase the first available number
        user_id: userId,
        provider: 'SIP Trunking',
        inbound_webhook_url: 'https://ccv76evyok.execute-api.ap-southeast-2.amazonaws.com/prod/voice', // Default webhook URL
        agent_id: defaultAgentId // Include agent_id if available (same as CreateAgentForm)
      };
      
      // Use the Twilio purchase endpoint (same as original code)
      const response = await fetch(`${API_BASE_URL}/api/twilio/purchase-phone-number`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(defaultPurchaseData),
      });

      const data = await response.json();

      if (data.success) {
        // Create a new phone number object to add to the list using Twilio data
        const newPhoneNumber = {
          id: data.purchased?.phone_number || 'N/A',
          name: data.purchased?.friendly_name || data.purchased?.phone_number || 'Twilio Number',
          phoneNumber: data.purchased?.phone_number || 'N/A',
          terminationUri: null, // Will be configured later
          sipTrunkUserName: null,
          sipTrunkPassword: null,
          nickname: data.purchased?.friendly_name || data.purchased?.phone_number || 'Twilio Number',
          connectionStatus: 'purchased',
          provider: 'Twilio',
          inboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available',
          outboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available',
          webhook: false,
          twilioData: data.purchased,
          pricing: data.pricing,
          created_at: new Date().toISOString(),
          last_modification_timestamp: new Date().toISOString()
        };
        
        // Add the new phone number to the existing list
        setPhoneNumbers(prev => [newPhoneNumber, ...prev]);
        setInboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
        setOutboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
        
        const pricingInfo = data.pricing ? `\n• Monthly Cost: $${data.pricing.monthly_cost} ${data.pricing.currency}` : '';
        const agentInfo = defaultAgentId ? `\n• Associated Agent: ${availableAgents[0].agent_name} (${defaultAgentId})` : '\n• Agent Association: None (will be assigned later)';
        
        let successMessage = `✅ Phone number purchased successfully from Twilio and saved to database!
        
Purchase Details:
• Phone Number: ${data.purchased?.phone_number || 'N/A'}
• Friendly Name: ${data.purchased?.friendly_name || 'N/A'}
• Twilio SID: ${data.purchased?.sid || 'N/A'}
• Capabilities: ${JSON.stringify(data.purchased?.capabilities || {})}
• Provider: Twilio
• Status: Purchased and ready for configuration${pricingInfo}${agentInfo}
`;

        if (data.retell_import === 'success') {
          successMessage += `
• Retell Import: Successful - Number registered with Retell AI

Next Steps:
1. Assign agents for inbound/outbound calls
2. Test calls!`;
        } else {
          successMessage += `
⚠️ Retell Import: Failed - Number NOT registered with Retell AI (outbound calls may not work)
   - Check server logs for Retell import error
   - Try manual import or contact support

Next Steps:
1. Configure SIP trunking settings manually
2. Assign agents for inbound/outbound calls
3. Set up webhook endpoints`;
        }

        setSuccess(successMessage);
      } else {
        let errorMessage = data.error || 'Failed to purchase phone number from Twilio';
        
        if (data.error && data.error.includes('credentials')) {
          errorMessage = '❌ Twilio credentials not configured. Please contact your administrator to set up TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN environment variables.';
        } else if (data.error && data.error.includes('TWILIO_ACCOUNT_SID') || data.error.includes('TWILIO_AUTH_TOKEN')) {
          errorMessage = '❌ Twilio credentials not configured. Please contact your administrator to set up TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN environment variables.';
        } else if (data.error && data.error.includes('No available numbers')) {
          errorMessage = 'No phone numbers available matching your criteria. Try different search parameters.';
        } else if (data.error && data.error.includes('country')) {
          errorMessage = 'Invalid country code. Please use a valid ISO 2-letter country code (e.g., "AU" for Australia).';
        } else if (data.error && data.error.includes('number_type')) {
          errorMessage = 'Invalid number type. Must be "local", "mobile", or "toll_free".';
        } else if (data.error && data.error.includes('area_code')) {
          errorMessage = 'Area code is only applicable for local numbers.';
        } else if (data.error && data.error.includes('limit')) {
          errorMessage = 'Limit must be between 1 and 1000.';
        } else if (data.error && data.error.includes('quota') || data.error.includes('limit')) {
          errorMessage = 'Twilio quota exceeded or limit reached. Please check your account limits.';
        } else if (data.error && data.error.includes('network') || data.error.includes('timeout')) {
          errorMessage = 'Network error connecting to Twilio servers. Please check your internet connection.';
        }
        
        setError(errorMessage);
      }
    } catch (error) {
      console.error('Error connecting numbers:', error);
      setError('Network error connecting to the server. Please check your connection and try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');

    // Check if user ID is available
    if (!userId) {
      setError('User ID is not available. Please refresh the page and try again.');
      setSubmitting(false);
      return;
    }

    try {
      const userEmail = getUserEmail();
      
      // Show initial connection message
      setSuccess('Sending details to Retell SIP trunking service...');
      
      // Use the import phone number endpoint for SIP trunking
      const response = await fetch(`${API_BASE_URL}/api/import-phone-number`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phone_number: formData.phoneNumber,
          termination_uri: formData.terminationUri,
          sip_trunk_auth_username: formData.sipTrunkUserName || undefined,
          sip_trunk_auth_password: formData.sipTrunkPassword || undefined,
          nickname: formData.nickname || formData.phoneNumber,
          inbound_webhook_url: 'https://ccv76evyok.execute-api.ap-southeast-2.amazonaws.com/prod/voice', // Default webhook URL
          user_id: userId
        }),
      });

      const data = await response.json();

             if (data.success) {
         // Create a new phone number object to add to the list using database data
         const newPhoneNumber = {
           id: data.data?.phone_number || formData.phoneNumber,
           name: data.data?.nickname || formData.nickname || formData.phoneNumber,
           phoneNumber: data.data?.phone_number || formData.phoneNumber,
           terminationUri: data.data?.termination_uri || formData.terminationUri,
           sipTrunkUserName: data.data?.sip_trunk_auth_username || formData.sipTrunkUserName,
           sipTrunkPassword: data.data?.sip_trunk_auth_password || formData.sipTrunkPassword,
           nickname: data.data?.nickname || formData.nickname,
           connectionStatus: 'connected',
           provider: 'Retell',
           inboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', // Use first available agent
           outboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', // Use first available agent
           webhook: true, // Webhook is automatically configured with default URL
           webhookUrl: 'https://ccv76evyok.execute-api.ap-southeast-2.amazonaws.com/prod/voice', // Default webhook URL
           retellData: data.data,
           created_at: data.data?.created_at,
           last_modification_timestamp: data.data?.last_modification_timestamp
         };
         
         // Add the new phone number to the existing list
         setPhoneNumbers(prev => [newPhoneNumber, ...prev]);
         setInboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_id : 'No agents available', ...prev]);
         setOutboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_id : 'No agents available', ...prev]);
         
         setSuccess(`✅ Connection established successfully with Retell SIP trunking and saved to database!
         
Connection Details:
• Phone Number: ${data.data?.phone_number || formData.phoneNumber}
• Termination URI: ${data.data?.termination_uri || formData.terminationUri}
• Nickname: ${data.data?.nickname || formData.nickname}
• Webhook URL: https://ccv76evyok.execute-api.ap-southeast-2.amazonaws.com/prod/voice (Auto-configured)
• User ID: ${data.data?.user_id || userId}
• Status: Active and ready for calls
• Database ID: ${data.data?.phone_number || 'N/A'}`);
         
         setShowModal(false);
         setFormData({
           phoneNumber: '',
           terminationUri: '',
           sipTrunkUserName: '',
           sipTrunkPassword: '',
           nickname: ''
         });
             } else {
         // Check if the error is due to phone number already existing in Retell
         if (data.details && data.details.includes('already exists')) {
           // Create a new phone number object to add to the list using database data
           const newPhoneNumber = {
             id: data.data?.phone_number || formData.phoneNumber,
             name: data.data?.nickname || formData.nickname || formData.phoneNumber,
             phoneNumber: data.data?.phone_number || formData.phoneNumber,
             terminationUri: data.data?.termination_uri || formData.terminationUri,
             sipTrunkUserName: data.data?.sip_trunk_auth_username || formData.sipTrunkUserName,
             sipTrunkPassword: data.data?.sip_trunk_auth_password || formData.sipTrunkPassword,
             nickname: data.data?.nickname || formData.nickname,
             connectionStatus: 'connected',
             provider: 'Retell',
             inboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', // Use first available agent
             outboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', // Use first available agent
             webhook: false,
             retellData: data.data,
             alreadyExists: true,
             created_at: data.data?.created_at,
             last_modification_timestamp: data.data?.last_modification_timestamp
           };
           
           // Add the new phone number to the existing list
           setPhoneNumbers(prev => [newPhoneNumber, ...prev]);
           setInboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
           setOutboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
           
           setSuccess(`✅ Phone number ${data.data?.phone_number || formData.phoneNumber} already exists in Retell and has been saved to your database!

          Connection Details:
          • Phone Number: ${data.data?.phone_number || formData.phoneNumber}
          • Termination URI: ${data.data?.termination_uri || formData.terminationUri}
          • Nickname: ${data.data?.nickname || formData.nickname}
          • User ID: ${data.data?.user_id || userId}
          • Status: Already connected in Retell
          • Note: This number was already imported in Retell and is now available in your dashboard`);
            
           setShowModal(false);
           setFormData({
             phoneNumber: '',
             terminationUri: '',
             sipTrunkUserName: '',
             sipTrunkPassword: '',
             nickname: ''
           });
         } else {
           // Provide more specific error messages based on the response
           let errorMessage = data.error || 'Failed to establish connection with Retell SIP trunking';
           
           if (data.details && data.details.includes('phone_number')) {
             errorMessage = 'Invalid phone number format. Please use E.164 format (+country code, then number).';
           } else if (data.details && data.details.includes('termination_uri')) {
             errorMessage = 'Invalid termination URI format. Please check the URI and try again.';
           } else if (data.details && data.details.includes('auth')) {
             errorMessage = 'Invalid SIP trunk authentication credentials. Please check your username and password.';
           } else if (data.details && data.details.includes('quota') || data.details.includes('limit')) {
             errorMessage = 'Retell quota exceeded or limit reached. Please check your account limits.';
           } else if (data.details && data.details.includes('network') || data.details.includes('timeout')) {
             errorMessage = 'Network error connecting to Retell servers. Please check your internet connection.';
           } else if (data.details && data.details.includes('API key') || data.details.includes('unauthorized')) {
             errorMessage = 'Invalid or expired API key. Please check your Retell configuration.';
           }
           
           setError(errorMessage);
         }
       }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('Network error connecting to the server. Please check your connection and try again.');
    } finally {
      setSubmitting(false);
      setIsConnecting(false);
    }
  };

  // Function to fetch phone numbers for a specific agent and display in JSON format
  const fetchPhoneNumbersForAgent = async (agentId, agentType) => {
    try {
      setSuccess('🔄 Fetching phone numbers for agent...');
      
      const response = await fetch(`${API_BASE_URL}/api/agents/${agentId}/phone-numbers?user_id=${encodeURIComponent(userId)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });
      const data = await response.json();
      
      if (data.success) {
        const phoneNumbersList = data.phoneNumbers || [];
        
        // Create JSON format data
        const jsonData = {
          agent_id: agentId,
          agent_type: agentType,
          phone_numbers: phoneNumbersList.map(phone => ({
            id: phone.id,
            phone_number: phone.phone_number || phone.phone_numbers,
            nickname: phone.nickname,
            termination_uri: phone.termination_uri,
            connection_status: phone.connection_status,
            provider: phone.provider,
            created_at: phone.created_at
          })),
          total_count: phoneNumbersList.length,
          timestamp: new Date().toISOString()
        };
        
        // Only open the modal if explicitly requested
        // setAgentPhoneNumbersJson(jsonData);
        // setShowPhoneNumbersJsonModal(true);
        
        setSuccess(`✅ Found ${phoneNumbersList.length} phone numbers for ${agentType} agent`);
        console.log('📞 Phone numbers for agent:', jsonData);
        
        return jsonData;
      } else {
        setError(`❌ Failed to fetch phone numbers: ${data.error || 'Unknown error'}`);
        return null;
      }
    } catch (error) {
      console.error('Error fetching phone numbers for agent:', error);
      setError('Network error fetching phone numbers. Please check your connection and try again.');
      return null;
    }
  };



  const handleInboundCall = async (phoneNumberId) => {
    try {
      // Find the phone number index to get the inbound agent
      const phoneNumberIndex = phoneNumbers.findIndex(p => p.id === phoneNumberId);
      if (phoneNumberIndex === -1) {
        setError('❌ Phone number not found');
        return;
      }

      // Get the inbound agent for this phone number
      const inboundAgent = inboundAgents[phoneNumberIndex];
      if (!inboundAgent || inboundAgent === 'Click "Change Agent" to assign' || inboundAgent === 'No agents available') {
        setError('❌ Please assign an inbound agent to this phone number before registering for inbound calls');
        return;
      }

             // Find the corresponding Retell AI agent ID for this website agent
       const websiteAgent = availableAgents.find(agent => agent.agent_name === inboundAgent);
       if (!websiteAgent) {
         setError(`❌ Agent "${inboundAgent}" not found in available agents. Please check agent configuration.`);
         return;
       }
       
       if (!websiteAgent.retell_agent_id) {
         setError(`❌ Agent "${inboundAgent}" is not properly configured with Retell AI. 
         
        To fix this:
        1. Go to the Agents section
        2. Find agent "${inboundAgent}"
        3. Click "Configure with Retell AI"
        4. Enter the Retell AI agent ID for this agent
        5. Save the configuration
        6. Try registering for inbound calls again`);
         return;
       }

      // Get the phone number details to preserve Retell data
      const phoneNumber = phoneNumbers[phoneNumberIndex];

      console.log('📞 Initiating inbound call registration with preserved agent mapping and Retell data:', {
        phoneNumberId, // This is the phone number that will receive incoming calls
        websiteAgentName: inboundAgent, // Website agent name
        retellAgentId: websiteAgent.retell_agent_id, // Retell AI agent ID
        phoneNumberData: phoneNumber, // Preserve phone number data
        retellData: phoneNumber.retellData // Preserve existing Retell data
      });
      
      const response = await fetch(`${API_BASE_URL}/api/phone-calls/inbound`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phoneNumberId, // The phone number from database that will receive calls
          websiteAgentName: inboundAgent, // Website agent name for reference
          retellAgentId: websiteAgent.retell_agent_id, // Actual Retell AI agent ID to use
          callType: 'inbound',
          direction: 'inbound',
          // Preserve existing phone number data to prevent overwriting
          phoneNumberData: {
            id: phoneNumber.id,
            phoneNumber: phoneNumber.phoneNumber || phoneNumber.id,
            nickname: phoneNumber.nickname,
            terminationUri: phoneNumber.terminationUri,
            sipTrunkUserName: phoneNumber.sipTrunkUserName,
            sipTrunkPassword: phoneNumber.sipTrunkPassword,
            connectionStatus: phoneNumber.connectionStatus,
            provider: phoneNumber.provider,
            retellData: phoneNumber.retellData, // Preserve existing Retell data
            created_at: phoneNumber.created_at,
            last_modification_timestamp: phoneNumber.last_modification_timestamp
          },
          // Ensure agent mapping is preserved
          agentMapping: {
            websiteAgentName: inboundAgent,
            retellAgentId: websiteAgent.retell_agent_id,
            agentType: 'inbound',
            phoneNumberId: phoneNumberId
          }
        }),
      });

      const data = await response.json();
      
      if (data.success) {
        setSuccess(`✅ Inbound call registered successfully with preserved agent mapping!
        
        Call Details:
        • Phone Number: ${data.data.to || phoneNumber.phoneNumber || phoneNumberId} (Your phone number)
        • Website Agent: ${inboundAgent}
        • Retell Agent ID: ${websiteAgent.retell_agent_id}
        • Call Type: ${data.data.callType || 'inbound'}
        • Direction: inbound
        • Status: Ready to receive calls
        • Timestamp: ${new Date(data.data.timestamp || Date.now()).toLocaleString()}
        • Phone Number Details: ${data.data.phoneNumberDetails?.phoneNumber || phoneNumber.phoneNumber || phoneNumberId}
        • Nickname: ${data.data.phoneNumberDetails?.nickname || phoneNumber.nickname || 'N/A'}
        • Agent Mapping: Successfully preserved and mapped to correct Retell AI agent
        • Retell Data: Preserved existing configuration

        Your phone number is now ready to receive incoming calls with the correct agent and preserved Retell configuration!`);

        console.log('✅ Inbound call registered successfully with preserved agent mapping:', data);
      } else {
        setError(`❌ Failed to register inbound call: ${data.error}`);
        console.error('❌ Inbound call registration failed:', data.error);
      }
    } catch (error) {
      console.error('Error registering inbound call:', error);
      setError('Network error connecting to the server. Please check your connection and try again.');
    }
  };

  const handleOutboundCall = async (phoneNumberId) => {
    setOutboundCallLoading(true);
    setError('');
    setSuccess('');
    
    try {
      // Find the phone number index to get the outbound agent
      const phoneNumberIndex = phoneNumbers.findIndex(p => p.id === phoneNumberId);
      if (phoneNumberIndex === -1) {
        setError('❌ Phone number not found');
        setOutboundCallLoading(false);
        return;
      }

      // Get the outbound agent for this phone number
      const outboundAgent = outboundAgents[phoneNumberIndex];
      if (!outboundAgent || outboundAgent === 'Click "Change Agent" to assign' || outboundAgent === 'No agents available') {
        setError('❌ Please assign an outbound agent to this phone number before making calls');
        setOutboundCallLoading(false);
        return;
      }

                   // Find the corresponding Retell AI agent ID for this website agent
      const websiteAgent = availableAgents.find(agent => agent.agent_name === outboundAgent);
      if (!websiteAgent) {
        setError(`❌ Agent "${outboundAgent}" not found in available agents. Please check agent configuration.`);
        setOutboundCallLoading(false);
        return;
      }
      
      // Check if agent has a Retell AI agent ID configured
      let retellAgentId = websiteAgent.agent_id || websiteAgent.retell_agent_id;
      
      // If no Retell agent ID is configured, show a warning but allow the call to proceed
      if (!retellAgentId) {
        const shouldProceed = window.confirm(
          `⚠️ Agent "${outboundAgent}" is not properly configured with Retell AI.\n\n` +
          `This might cause issues with the call. Would you like to:\n\n` +
          `1. Continue with the call (using agent name as fallback)\n` +
          `2. Cancel and configure the agent first\n\n` +
          `To properly configure the agent:\n` +
          `1. Go to the Agents section\n` +
          `2. Find agent "${outboundAgent}"\n` +
          `3. Click "Configure with Retell AI"\n` +
          `4. Enter the Retell AI agent ID for this agent\n` +
          `5. Save the configuration`
        );
        
        if (!shouldProceed) {
          return;
        }
        
        // Use agent name as fallback if no Retell agent ID is configured
        retellAgentId = outboundAgent;
        console.log(`⚠️ Using agent name "${outboundAgent}" as fallback for Retell agent ID`);
      }

      // Get the phone number details to preserve Retell data
      const phoneNumber = phoneNumbers[phoneNumberIndex];
      
      // Prompt user for their phone number (the number they want to be called)
      const userPhoneNumber = prompt(
        'Please enter the phone number you want to call:\n\n' +
        'Format: +[country code][phone number]\n' +
        'Examples:\n' +
        '• US: +1234567890\n' +
        '• UK: +44123456789\n' +
        '• India: +919876543210\n\n' +
        'Enter phone number:'
      );
      
      if (!userPhoneNumber) {
        console.log('User cancelled outbound call');
        setOutboundCallLoading(false);
        return;
      }
      
      // Enhanced validation on frontend
      const phoneRegex = /^\+[1-9]\d{1,14}$/;
      const trimmedNumber = userPhoneNumber.trim();
      
      if (!phoneRegex.test(trimmedNumber)) {
        let errorMessage = '❌ Invalid phone number format.\n\n';
        
        // Provide specific guidance based on input
        if (trimmedNumber.length === 10 && !trimmedNumber.startsWith('+')) {
          errorMessage += 'You entered a 10-digit number. For US numbers, please use:\n';
          errorMessage += '• +1' + trimmedNumber + ' (recommended)\n\n';
        } else if (trimmedNumber.length === 11 && trimmedNumber.startsWith('1')) {
          errorMessage += 'You entered an 11-digit number starting with 1. Please use:\n';
          errorMessage += '• +' + trimmedNumber + ' (recommended)\n\n';
        } else {
          errorMessage += 'Please use E.164 format: +[country code][number]\n\n';
        }
        
        errorMessage += 'Examples:\n';
        errorMessage += '• US: +1234567890\n';
        errorMessage += '• UK: +44123456789\n';
        errorMessage += '• India: +919876543210\n\n';
        errorMessage += 'Your input: ' + userPhoneNumber;
        
        setError(errorMessage);
        setOutboundCallLoading(false);
        return;
      }
      
      console.log('📞 Initiating outbound call with preserved agent mapping and Retell data:', {
        phoneNumberId, // This is the "from" number (stored in database)
        userPhoneNumber, // This is the "to" number (user's input)
        websiteAgentName: outboundAgent, // Website agent name
        retellAgentId: retellAgentId, // Retell AI agent ID
        phoneNumberData: phoneNumber, // Preserve phone number data
        retellData: phoneNumber.retellData // Preserve existing Retell data
      });
      
      console.log('🔄 Sending request to backend...');
      
      // Create AbortController for timeout handling
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout
      
      const response = await fetch(`${API_BASE_URL}/api/phone-calls/outbound`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        signal: controller.signal,
        body: JSON.stringify({
          phoneNumberId, // The phone number from database will be used as "from"
          userPhoneNumber: trimmedNumber, // The validated and trimmed number will be used as "to"
          websiteAgentName: outboundAgent, // Website agent name for reference
          retellAgentId: retellAgentId, // Actual Retell AI agent ID to use
          callType: 'outbound',
          direction: 'outbound',
          // Preserve existing phone number data to prevent overwriting
          phoneNumberData: {
            id: phoneNumber.id,
            phoneNumber: phoneNumber.phoneNumber || phoneNumber.id,
            nickname: phoneNumber.nickname,
            terminationUri: phoneNumber.terminationUri,
            sipTrunkUserName: phoneNumber.sipTrunkUserName,
            sipTrunkPassword: phoneNumber.sipTrunkPassword,
            connectionStatus: phoneNumber.connectionStatus,
            provider: phoneNumber.provider,
            retellData: phoneNumber.retellData, // Preserve existing Retell data
            created_at: phoneNumber.created_at,
            last_modification_timestamp: phoneNumber.last_modification_timestamp
          },
          // Ensure agent mapping is preserved
          agentMapping: {
            websiteAgentName: outboundAgent,
            retellAgentId: retellAgentId,
            agentType: 'outbound',
            phoneNumberId: phoneNumberId
          }
        }),
      });
      
      clearTimeout(timeoutId);
      console.log('✅ Response received from backend, status:', response.status);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      console.log('📊 Response data:', data);
      
      if (data.success) {
                 const isFallback = retellAgentId === outboundAgent;
         setSuccess(`Connected! Your call is live with the agent`);

        console.log('✅ Phone call created successfully with preserved agent mapping:', data);
        console.log('📊 Call Details:', {
          call_id: data.data.call_id || 'N/A',
          from: data.data.from_number || phoneNumber.phoneNumber || phoneNumberId,
          to: data.data.to_number || userPhoneNumber,
          website_agent: outboundAgent,
          retell_agent_id: retellAgentId,
          call_type: data.data.call_type || 'outbound',
          direction: data.data.direction || 'outbound',
          status: data.data.call_status || 'Creating',
          timestamp: new Date(data.data.timestamp || Date.now()).toLocaleString(),
          phone_number_details: data.data.phoneNumberDetails?.phoneNumber || phoneNumber.phoneNumber || phoneNumberId,
          nickname: data.data.phoneNumberDetails?.nickname || phoneNumber.nickname || 'N/A',
          agent_mapping: isFallback ? 'Using fallback configuration' : 'Successfully preserved and mapped to correct Retell AI agent',
          retell_data: 'Preserved existing configuration'
        });
      } else {
        setError(`❌ Failed to create phone call: ${data.error}`);
        console.error('❌ Phone call failed:', data.error);
      }
      
      setOutboundCallLoading(false);
    } catch (error) {
      console.error('❌ Error initiating outbound call:', error);
      
      if (error.name === 'AbortError') {
        setError('❌ Request timed out after 30 seconds. The server may be slow or unresponsive. Please try again.');
      } else if (error.message && error.message.includes('HTTP error')) {
        setError(`❌ Server error: ${error.message}. Please check your connection and try again.`);
      } else {
        setError('❌ Network error connecting to the server. Please check your connection and try again.');
      }
      
      setOutboundCallLoading(false);
    }
  };

  const handleDirectTwilioPurchase = async () => {
    setSubmitting(true);
    setError('');
    setSuccess('');

    // Check if user ID is available
    if (!userId) {
      setError('User ID is not available. Please refresh the page and try again.');
      setSubmitting(false);
      setIsConnecting(false);
      return;
    }

    try {
      const userEmail = getUserEmail();
      
      // Show initial connection message
      setSuccess('Connecting to Twilio and purchasing phone number...');
      
      // Log the request data for debugging
      console.log('📞 Purchasing Twilio phone number with user ID:', userId);
      
      // Get the first available agent to associate with the phone number
      let defaultAgentId = null;
      if (availableAgents && availableAgents.length > 0) {
        defaultAgentId = availableAgents[0].agent_id;
        console.log('📞 Found available agent for phone number association:', {
          agent_name: availableAgents[0].agent_name,
          agent_id: defaultAgentId
        });
      } else {
        console.log('📞 No available agents found - phone number will be created without agent association');
      }
      
      // Use default values for direct purchase
      const defaultPurchaseData = {
        country: 'AU',
        number_type: 'local',
        area_code: undefined,
        contains: undefined,
        voice_enabled: true,
        sms_enabled: false,
        limit: 10,
        auto_buy_first: true, // Automatically purchase the first available number
        user_id: userId,
        agent_id: defaultAgentId // Include agent_id if available
      };
      
      // Use the new Twilio purchase endpoint
      const response = await fetch(`${API_BASE_URL}/api/twilio/purchase-phone-number`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(defaultPurchaseData),
      });

      const data = await response.json();

      if (data.success) {
        // Create a new phone number object to add to the list using Twilio data
        const newPhoneNumber = {
          id: data.purchased?.phone_number || 'N/A',
          name: data.purchased?.friendly_name || data.purchased?.phone_number || 'Twilio Number',
          phoneNumber: data.purchased?.phone_number || 'N/A',
          terminationUri: null, // Will be configured later
          sipTrunkUserName: null,
          sipTrunkPassword: null,
          nickname: data.purchased?.friendly_name || data.purchased?.phone_number || 'Twilio Number',
          connectionStatus: 'purchased',
          provider: 'Twilio',
          inboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available',
          outboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available',
          webhook: false,
          twilioData: data.purchased,
          pricing: data.pricing,
          created_at: new Date().toISOString(),
          last_modification_timestamp: new Date().toISOString()
        };
        
        // Add the new phone number to the existing list
        setPhoneNumbers(prev => [newPhoneNumber, ...prev]);
        setInboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
        setOutboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
        
        const pricingInfo = data.pricing ? `\n• Monthly Cost: $${data.pricing.monthly_cost} ${data.pricing.currency}` : '';
        
        const agentInfo = defaultAgentId ? `\n• Associated Agent: ${availableAgents[0].agent_name} (${defaultAgentId})` : '\n• Agent Association: None (will be assigned later)';
        
        let successMessage = `✅ Phone number purchased successfully from Twilio and saved to database!
        
Purchase Details:
• Phone Number: ${data.purchased?.phone_number || 'N/A'}
• Friendly Name: ${data.purchased?.friendly_name || 'N/A'}
• Twilio SID: ${data.purchased?.sid || 'N/A'}
• Capabilities: ${JSON.stringify(data.purchased?.capabilities || {})}
• Provider: Twilio
• Status: Purchased and ready for configuration${pricingInfo}${agentInfo}
`;

        if (data.retell_import === 'success') {
          successMessage += `
• Retell Import: Successful - Number registered with Retell AI

Next Steps:
1. Assign agents for inbound/outbound calls
2. Test calls!`;
        } else {
          successMessage += `
⚠️ Retell Import: Failed - Number NOT registered with Retell AI (outbound calls may not work)
   - Check server logs for Retell import error
   - Try manual import or contact support

Next Steps:
1. Configure SIP trunking settings manually
2. Assign agents for inbound/outbound calls
3. Set up webhook endpoints`;
        }

        setSuccess(successMessage);
      } else {
        let errorMessage = data.error || 'Failed to purchase phone number from Twilio';
        
        if (data.error && data.error.includes('credentials')) {
          errorMessage = '❌ Twilio credentials not configured. Please contact your administrator to set up TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN environment variables.';
        } else if (data.error && data.error.includes('TWILIO_ACCOUNT_SID') || data.error.includes('TWILIO_AUTH_TOKEN')) {
          errorMessage = '❌ Twilio credentials not configured. Please contact your administrator to set up TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN environment variables.';
        } else if (data.error && data.error.includes('No available numbers')) {
          errorMessage = 'No phone numbers available matching your criteria. Try different search parameters.';
        } else if (data.error && data.error.includes('country')) {
          errorMessage = 'Invalid country code. Please use a valid ISO 2-letter country code (e.g., "AU" for Australia).';
        } else if (data.error && data.error.includes('number_type')) {
          errorMessage = 'Invalid number type. Must be "local", "mobile", or "toll_free".';
        } else if (data.error && data.error.includes('area_code')) {
          errorMessage = 'Area code is only applicable for local numbers.';
        } else if (data.error && data.error.includes('limit')) {
          errorMessage = 'Limit must be between 1 and 1000.';
        } else if (data.error && data.error.includes('quota') || data.error.includes('limit')) {
          errorMessage = 'Twilio quota exceeded or limit reached. Please check your account limits.';
        } else if (data.error && data.error.includes('network') || data.error.includes('timeout')) {
          errorMessage = 'Network error connecting to Twilio servers. Please check your internet connection.';
        }
        
        setError(errorMessage);
        setIsConnecting(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('Network error connecting to the server. Please check your connection and try again.');
      setIsConnecting(false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDirectTwilioPurchaseFromCode = async () => {
    setSubmitting(true);
    setError('');
    setSuccess('');

    // Check if user ID is available
    if (!userId) {
      setError('User ID is not available. Please refresh the page and try again.');
      setSubmitting(false);
      setIsConnecting(false);
      return;
    }

    try {
      const userEmail = getUserEmail();
      
      // Show initial connection message
      setSuccess('Connecting to Twilio and purchasing phone number...');
      
      // Log the request data for debugging
      console.log('📞 Purchasing Twilio phone number with user ID:', userId);
      
      // Use default values for direct purchase
      const defaultPurchaseData = {
        country: 'AU',
        number_type: 'local',
        area_code: undefined,
        contains: undefined,
        voice_enabled: true,
        sms_enabled: false,
        limit: 10,
        auto_buy_first: true, // Automatically purchase the first available number
        user_id: userId
      };
      
      // Use the new Twilio purchase endpoint
      const response = await fetch(`${API_BASE_URL}/api/twilio/purchase-phone-number`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(defaultPurchaseData),
      });

      const data = await response.json();

      if (data.success) {
        // Create a new phone number object to add to the list using Twilio data
        const newPhoneNumber = {
          id: data.purchased?.phone_number || 'N/A',
          name: data.purchased?.friendly_name || data.purchased?.phone_number || 'Twilio Number',
          phoneNumber: data.purchased?.phone_number || 'N/A',
          terminationUri: null, // Will be configured later
          sipTrunkUserName: null,
          sipTrunkPassword: null,
          nickname: data.purchased?.friendly_name || data.purchased?.phone_number || 'Twilio Number',
          connectionStatus: 'purchased',
          provider: 'Twilio',
          inboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available',
          outboundAgent: availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available',
          webhook: false,
          twilioData: data.purchased,
          pricing: data.pricing,
          created_at: new Date().toISOString(),
          last_modification_timestamp: new Date().toISOString()
        };
        
        // Add the new phone number to the existing list
        setPhoneNumbers(prev => [newPhoneNumber, ...prev]);
        setInboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
        setOutboundAgents(prev => [availableAgents.length > 0 ? availableAgents[0].agent_name : 'No agents available', ...prev]);
        
        const pricingInfo = data.pricing ? `\n• Monthly Cost: $${data.pricing.monthly_cost} ${data.pricing.currency}` : '';
        
        setSuccess(`✅ Phone number purchased successfully from Twilio and saved to database!
        
Purchase Details:
• Phone Number: ${data.purchased?.phone_number || 'N/A'}
• Friendly Name: ${data.purchased?.friendly_name || 'N/A'}
• Twilio SID: ${data.purchased?.sid || 'N/A'}
• Capabilities: ${JSON.stringify(data.purchased?.capabilities || {})}
• Provider: Twilio
• Status: Purchased and ready for configuration${pricingInfo}

Next Steps:
1. Configure SIP trunking settings
2. Assign agents for inbound/outbound calls
3. Set up webhook endpoints`);
        
        setIsConnecting(false);
      } else {
        // Provide more specific error messages based on the Twilio response
        let errorMessage = data.error || 'Failed to purchase phone number from Twilio';
        
        if (data.error && data.error.includes('credentials')) {
          errorMessage = '❌ Twilio credentials not configured. Please contact your administrator to set up TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN environment variables.';
        } else if (data.error && data.error.includes('TWILIO_ACCOUNT_SID') || data.error.includes('TWILIO_AUTH_TOKEN')) {
          errorMessage = '❌ Twilio credentials not configured. Please contact your administrator to set up TWILIO_ACCOUNT_SID and TWILIO_AUTH_TOKEN environment variables.';
        } else if (data.error && data.error.includes('No available numbers')) {
          errorMessage = 'No phone numbers available matching your criteria. Try different search parameters.';
        } else if (data.error && data.error.includes('country')) {
          errorMessage = 'Invalid country code. Please use a valid ISO 2-letter country code (e.g., "AU" for Australia).';
        } else if (data.error && data.error.includes('number_type')) {
          errorMessage = 'Invalid number type. Must be "local", "mobile", or "toll_free".';
        } else if (data.error && data.error.includes('area_code')) {
          errorMessage = 'Area code is only applicable for local numbers.';
        } else if (data.error && data.error.includes('limit')) {
          errorMessage = 'Limit must be between 1 and 1000.';
        } else if (data.error && data.error.includes('quota') || data.error.includes('limit')) {
          errorMessage = 'Twilio quota exceeded or limit reached. Please check your account limits.';
        } else if (data.error && data.error.includes('network') || data.error.includes('timeout')) {
          errorMessage = 'Network error connecting to Twilio servers. Please check your internet connection.';
        }
        
        setError(errorMessage);
        setIsConnecting(false);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setError('Network error connecting to the server. Please check your connection and try again.');
      setIsConnecting(false);
    } finally {
      setSubmitting(false);
    }
  };

  const handleDeletePhoneNumber = async (phoneNumberId) => {
    // Find the phone number details for better confirmation message
    const phoneNumber = phoneNumbers.find(p => p.id === phoneNumberId);
    const phoneDisplay = phoneNumber ? (phoneNumber.phoneNumber || phoneNumber.id) : phoneNumberId;
    const nicknameDisplay = phoneNumber?.nickname ? ` (${phoneNumber.nickname})` : '';
    
    const confirmMessage = `Are you sure you want to delete this phone number?\n\n` +
      `Phone Number: ${phoneDisplay}${nicknameDisplay}\n\n` +
      `This will delete the phone number from both:\n` +
      `• Your database\n` +
      `• Retell AI system\n\n` +
      `This action cannot be undone.`;
    
    if (window.confirm(confirmMessage)) {
      try {
        console.log('🗑️ Deleting phone number:', phoneNumberId);
        setError('');
        setSuccess('');
        setDeleteLoading(prev => ({ ...prev, [phoneNumberId]: true }));
        
        const response = await fetch(`${API_BASE_URL}/api/phone-numbers/${phoneNumberId}`, {
          method: 'DELETE',
        });

        if (response.ok) {
          const data = await response.json();
          console.log('✅ Phone number deleted successfully:', data);
          
          // Show success message with details
          setSuccess(`✅ Phone number deleted successfully!\n\n` +
            `Phone Number: ${data.data?.phone_number || phoneDisplay}\n` +
            `Nickname: ${data.data?.nickname || 'N/A'}\n` +
            `Deleted from Retell: ${data.data?.deleted_from_retell ? 'Yes' : 'No'}\n` +
            `Deleted from Database: ${data.data?.deleted_from_database ? 'Yes' : 'No'}\n\n` +
            `The phone number has been completely removed from the system.`);
          
          // Refresh phone numbers to remove the deleted one
          fetchPhoneNumbers();
        } else {
          const errorData = await response.json();
          console.error('❌ Failed to delete phone number:', errorData);
          setError(`❌ Failed to delete phone number: ${errorData.error || 'Unknown error'}`);
        }
      } catch (error) {
        console.error('❌ Error deleting phone number:', error);
        setError('❌ Network error deleting phone number. Please check your connection and try again.');
      } finally {
        setDeleteLoading(prev => ({ ...prev, [phoneNumberId]: false }));
      }
    }
  };

  // Function to fetch phone numbers from agent_phone_connection table for the inbound agent
  // This function CAPTURES the agent_id and phone_numbers data that will be used in webhook configuration
  // const fetchInboundAgentPhoneNumbers = async (phoneNumberId) => {
  //   try {
  //     // Find the phone number index to get the inbound agent
  //     const phoneNumberIndex = phoneNumbers.findIndex(p => p.id === phoneNumberId);
  //     if (phoneNumberIndex === -1) {
  //       setError('❌ Phone number not found');
  //       return;
  //     }

  //     // Get the inbound agent for this phone number
  //     const inboundAgent = inboundAgents[phoneNumberIndex];
  //     if (!inboundAgent || inboundAgent === 'Click "Change Agent" to assign' || inboundAgent === 'No agents available') {
  //       setError('❌ Please assign an inbound agent to this phone number first');
  //       return;
  //     }

  //     // Find the corresponding agent details
  //     const websiteAgent = availableAgents.find(agent => agent.agent_name === inboundAgent);
  //     if (!websiteAgent) {
  //       setError(`❌ Agent "${inboundAgent}" not found in available agents`);
  //       return;
  //     }

  //     if (!websiteAgent.agent_id) {
  //       setError(`❌ Agent "${inboundAgent}" does not have a valid agent ID`);
  //       return;
  //     }

  //     setSuccess('🔄 Fetching phone numbers from agent_phone_connection table...');

  //     // Simple API call to backend server.js
  //     const response = await fetch(`${API_BASE_URL}/api/agent-phone-connections/get-phone-numbers`, {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({
  //         user_id: userId,
  //         agent_id: websiteAgent.agent_id
  //       }),
  //     });

  //     const data = await response.json();
      
  //     if (data.success) {
  //       const phoneNumbersList = data.phoneNumbers || [];
        
  //       // CAPTURE: Create JSON format data with agent_id and phone_numbers
  //       // This data will be captured and used in the webhook configuration
  //       const jsonData = {
  //         agent_id: websiteAgent.agent_id, // CAPTURED: This agent_id will be used
  //         agent_name: inboundAgent,
  //         agent_type: 'inbound',
  //         user_id: userId,
  //         phone_numbers: phoneNumbersList, // CAPTURED: These phone numbers will be used
  //         total_count: phoneNumbersList.length,
  //         source_table: 'agent_phone_connection',
  //         timestamp: new Date().toISOString()
  //       };
        
  //       // Only open the modal if explicitly requested (for "Show Agent Numbers" button)
  //       // setAgentPhoneNumbersJson(jsonData);
  //       // setShowPhoneNumbersJsonModal(true);
        
  //       setSuccess(`✅ Found ${phoneNumbersList.length} phone numbers for inbound agent "${inboundAgent}" from agent_phone_connection table!`);
        
  //       console.log('📞 Phone numbers from agent_phone_connection table:', jsonData);
        
  //       return jsonData;
  //     } else {
  //       setError(`❌ Failed to fetch phone numbers: ${data.error || 'Unknown error'}`);
  //       return null;
  //     }
  //   } catch (error) {
  //     console.error('Error fetching phone numbers from agent_phone_connection:', error);
  //     setError('Network error fetching phone numbers. Please check your connection and try again.');
  //     return null;
  //   }
  // };

  // Function to update agent LLM model with transfer call functionality
  const updateAgentLLMWithTransferCall = async (agentId, phoneNumbers, transferTo) => {
    try {
      setLoading(true);
      setError(null);
      
      console.log(`🔧 Updating LLM model for agent ${agentId} with transfer call functionality`);
      console.log(`📞 Phone numbers:`, phoneNumbers);
      console.log(`📞 Transfer to: ${transferTo}`);
      
      const response = await fetch(`${API_BASE_URL}/api/agents/${agentId}/update-llm-transfer-call`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phone_numbers: phoneNumbers,
          transfer_to: transferTo
        }),
      });

      const data = await response.json();
      
      if (data.success) {
        setSuccess(`✅ Agent LLM model updated successfully with transfer call functionality!
        
      Transfer Configuration:
      • From phone numbers: ${data.transfer_config.from_phone_numbers.join(', ')}
      • Transfer to: ${data.transfer_config.transfer_to}
      • Dynamic variables configured for immediate transfer

      The agent will now automatically transfer calls from the configured phone numbers to ${transferTo} without any AI interaction.`);
        
        console.log('✅ Agent LLM updated successfully:', data);
        return data;
      } else {
        throw new Error(data.error || 'Failed to update agent LLM model');
      }
    } catch (error) {
      console.error('❌ Error updating agent LLM model:', error);
      setError(`Failed to update agent LLM model: ${error.message}`);
      return null;
    } finally {
      setLoading(false);
    }
  };

  // Function to handle transfer call configuration
  const handleTransferCallConfig = async () => {
    try {
      setLoading(true);
      setError(null);
      
      if (!transferCallConfig.destination_number.trim()) {
        setError('❌ Destination number is required for transfer call configuration');
        return;
      }
      
      console.log('🔧 Configuring transfer call with settings:', transferCallConfig);
      
      // Send transfer call configuration to backend
      const response = await fetch(`${API_BASE_URL}/api/agents/add-transfer-tool`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          // agent_id: agentPhoneNumbersJson?.agent_id, // COMMENTED OUT - Show Agent Numbers functionality
          agent_id: null, // Placeholder since agentPhoneNumbersJson is commented out
          tool_name: transferCallConfig.name,
          description: transferCallConfig.description,
          transfer_number: transferCallConfig.destination_number,
          transfer_type: transferCallConfig.transfer_type,
          transfer_to: transferCallConfig.transfer_to,
          displayed_phone_number: transferCallConfig.displayed_phone_number,
          custom_sip_headers: transferCallConfig.custom_sip_headers
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to configure transfer call');
      }

      const result = await response.json();
      console.log('✅ Transfer call configured successfully:', result);

      // Set the result to display
      setTransferCallResult({
        success: true,
        tool_name: transferCallConfig.name,
        destination_number: transferCallConfig.destination_number,
        transfer_type: transferCallConfig.transfer_type,
        transfer_to: transferCallConfig.transfer_to,
        displayed_phone_number: transferCallConfig.displayed_phone_number,
        backend_result: result,
        timestamp: new Date().toISOString()
      });

      setShowTransferResult(true);
      setShowTransferCallModal(false);
      
      setSuccess(`✅ Transfer Call tool successfully configured!
      
    Tool Name: ${transferCallConfig.name}
    Destination: ${transferCallConfig.destination_number}
    Transfer Type: ${transferCallConfig.transfer_type}
    Transfer To: ${transferCallConfig.transfer_to}`);

    } catch (error) {
      console.error('❌ Error configuring transfer call:', error);
      setError(`Failed to configure transfer call: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // Function to handle webhook configuration
  const handleWebhookConfig = async () => {
    try {
      setLoading(true);
      setError(null);
      
      if (!webhookConfig.agent_id.trim()) {
        setError('❌ Agent ID is required for webhook configuration');
        return;
      }
      
      console.log('🔧 Configuring webhook with settings:', webhookConfig);
      
      // Send webhook configuration to backend
      const response = await fetch(`${API_BASE_URL}/api/webhooks/configure`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          twilio_phone_number: selectedPhoneForWebhook?.phone_number,
          user_phone_number: webhookConfig.user_phone_number,
          agent_id: webhookConfig.agent_id,
          notification_phone: webhookConfig.notification_phone,
          verification_list: webhookConfig.verification_list,
          webhook_url: webhookConfig.webhook_url,
          post_call_webhook_url: webhookConfig.post_call_webhook_url
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to configure webhook');
      }

      const result = await response.json();
      console.log('✅ Webhook configured successfully:', result);

      // Set the result to display
      setWebhookResult({
        success: true,
        twilio_phone_number: selectedPhoneForWebhook?.phone_number,
        agent_id: webhookConfig.agent_id,
        webhook_url: webhookConfig.webhook_url,
        post_call_webhook_url: webhookConfig.post_call_webhook_url,
        verification_list: webhookConfig.verification_list,
        backend_result: result,
        timestamp: new Date().toISOString()
      });

      setShowWebhookResult(true);
      setShowWebhookModal(false);
      
      setSuccess(`✅ Webhook successfully configured!
      
      Twilio Phone Number: ${selectedPhoneForWebhook?.phone_number}
      Agent ID: ${webhookConfig.agent_id}
      Webhook URL: ${webhookConfig.webhook_url}
      Post-Call Webhook: ${webhookConfig.post_call_webhook_url}
      Transfer To: ${webhookConfig.user_phone_number || 'Auto-populated from agent config'}
      Verified Numbers: ${webhookConfig.verification_list.length > 0 ? webhookConfig.verification_list.join(', ') : 'Auto-populated from agent config'}`);

    } catch (error) {
      console.error('❌ Error configuring webhook:', error);
      setError(`Failed to configure webhook: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };



  // Function to show webhook JSON display
  const handleOpenWebhookModal = async (phoneNumber) => {
    setSelectedPhoneForWebhook(phoneNumber);
    
    try {
      // Get the inbound_agent_id from the phone number
      const inboundAgentId = phoneNumber.inbound_agent_id;
      
      console.log('🔍 Showing webhook JSON display for phone number:', phoneNumber);
      console.log('🔍 Phone number properties:', Object.keys(phoneNumber));
      console.log('🔍 inbound_agent_id:', inboundAgentId);
      console.log('🔍 Full phone number object:', JSON.stringify(phoneNumber, null, 2));
      
      if (inboundAgentId) {
        // Set all webhook config at once to avoid state update conflicts
        const newWebhookConfig = {
          user_phone_number: '',
          agent_id: inboundAgentId,
          notification_phone: '',
          verification_list: [],
          webhook_url: '',
          post_call_webhook_url: ''
        };
        
        console.log('✅ Setting webhook config with agent_id:', newWebhookConfig);
        setWebhookConfig(newWebhookConfig);
        
        // Try to fetch the agent's phone numbers to populate the verification list
        // COMMENTED OUT - Show Agent Numbers functionality
        // try {
        //   const agentPhoneNumbers = await fetchInboundAgentPhoneNumbers(phoneNumber.id);
          
        //   if (agentPhoneNumbers && agentPhoneNumbers.phone_numbers) {
        //     // CAPTURE: Extract agent_id and phone numbers from the JSON response
        //     const capturedAgentId = agentPhoneNumbers.agent_id;
        //     const capturedPhoneNumbers = agentPhoneNumbers.phone_numbers;
            
        //     console.log('🎯 CAPTURED DATA:', {
        //       agent_id: capturedAgentId,
        //       phone_numbers: capturedPhoneNumbers,
        //       total_count: capturedPhoneNumbers.length
        //     });
            
        //     // Extract phone numbers for verification list
        //     const phoneNumbersList = capturedPhoneNumbers.map(phone => 
        //       phone.phone_number || phone.phone_numbers
        //     ).filter(Boolean);
            
        //     // Update the config with CAPTURED data
        //     setWebhookConfig(prev => ({
        //       ...prev,
        //       agent_id: capturedAgentId, // Use captured agent_id
        //       verification_list: phoneNumbersList, // Use captured phone numbers
        //       // Set default transfer number to the first captured phone number if available
        //       user_phone_number: phoneNumbersList.length > 0 ? phoneNumbersList[0] : '',
        //       // Set notification phone to the first captured phone number if available
        //       notification_phone: phoneNumbersList.length > 0 ? phoneNumbersList[0] : ''
        //     }));
            
        //     // Store the JSON data for webhook configuration
        //     setAgentPhoneNumbersJson(agentPhoneNumbers);
            
        //     console.log('✅ CAPTURED and SET verification list and other fields:', phoneNumbersList);
        //     console.log('✅ CAPTURED agent_id:', capturedAgentId);
        //     console.log('✅ Stored JSON data for webhook:', agentPhoneNumbers);
        //   }
        // } catch (fetchError) {
        //   console.error('Error fetching agent phone numbers for webhook config:', fetchError);
        //   // Continue with just the agent_id set
        // }
      } else {
        console.log('⚠️ No inbound_agent_id found for phone number');
        // If no inbound_agent_id, set empty config
        setWebhookConfig({
          user_phone_number: '',
          agent_id: '',
          notification_phone: '',
          verification_list: [],
          webhook_url: '',
          post_call_webhook_url: ''
        });
      }
    } catch (error) {
      console.error('Error in webhook JSON display setup:', error);
      // If there's an error, set empty config
      setWebhookConfig({
        user_phone_number: '',
        agent_id: '',
        notification_phone: '',
        verification_list: [],
        webhook_url: '',
        post_call_webhook_url: ''
      });
    }
    
    setShowWebhookJsonDisplay(true);
  };



  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
      <div className="container d-flex flex-column h-100" style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: 'calc(100vh - 80px)' }}>
      <div style={{ background: '#fff', borderRadius: '50px', boxShadow: '0 4px 24px rgba(0,0,0,0.07)', padding: '20px', minWidth: '900px', maxWidth: '1100px', width: '100%', color: '#111', marginTop: '0', marginBottom: '48px', height: '500px', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <h2 style={{ fontWeight: 'bold', fontSize: '1.3rem', color: '#222', margin: 0, letterSpacing: '0.5px' }}>All Phone Numbers</h2>
            {userId && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{ 
                  width: '8px', 
                  height: '8px', 
                  borderRadius: '50%', 
                  backgroundColor: '#10b981',
                  animation: 'pulse 2s infinite',
                  display: 'none'
                }}></div>
                <span style={{ fontSize: '0.75rem', color: '#6b7280', fontWeight: '500', display: 'none' }}>
                  Authenticated as: {userId}
                </span>
              </div>
            )}
            {!userId && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{ 
                  width: '8px', 
                  height: '8px', 
                  borderRadius: '50%', 
                  backgroundColor: '#ef4444'
                }}></div>
                <span style={{ fontSize: '0.75rem', color: '#ef4444', fontWeight: '500' }}>
                  Not authenticated
                </span>
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {/* Connect Number button - commented out */}
            {/* <button 
              style={{ 
                background: '#111827', 
                color: '#fff', 
                border: 'none', 
                borderRadius: '8px', 
                padding: '8px 16px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                fontSize: '0.875rem', 
                fontWeight: '500', 
                cursor: isConnecting ? 'not-allowed' : 'pointer',
                opacity: isConnecting ? 0.7 : 1
              }} 
              title="Connect Number" 
              onClick={() => {
                setIsConnecting(true);
                // Directly trigger the Twilio purchase process without showing modal
                handleDirectTwilioPurchaseFromCode();
              }}
              disabled={isConnecting}
            >
              {isConnecting ? (
                <>
                  <i className="fas fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                  Connecting...
                </>
              ) : (
                <>
                  <i className="fas fa-link" style={{ marginRight: '6px' }}></i>
                  Connect Number
                </>
              )}
            </button> */}
            {/* + button - commented out */}
            {/* <button style={{ background: '#111827', color: '#fff', border: 'none', borderRadius: '50%', width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, cursor: 'pointer' }} title="Add Phone Number via SIP Trunking" onClick={() => setShowModal(true)}>
              <i className="fas fa-plus"></i>
            </button> */}
          </div>
        </div>

        {/* Success/Error Messages */}
        {success && (
          <div style={{ 
            background: '#d1fae5', 
            color: '#065f46', 
            padding: '12px 16px', 
            borderRadius: '8px', 
            marginBottom: '16px',
            border: '1px solid #a7f3d0'
          }}>
            {success}
          </div>
        )}
        
        {error && (
          <div style={{ 
            background: '#fee2e2', 
            color: '#991b1b', 
            padding: '12px 16px', 
            borderRadius: '8px', 
            marginBottom: '16px',
            border: '1px solid #fca5a5'
          }}>
            {error}
          </div>
        )}

        {/* Accordion list of phone numbers */}
        <div style={{ flex: 1, overflowY: 'auto', marginTop: 8 }}>
          {loading ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '200px', gap: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="fas fa-spinner fa-spin" style={{ color: '#3b82f6', fontSize: '1.2rem' }}></i>
                <div style={{ color: '#6b7280', fontSize: '1rem', fontWeight: '500' }}>
                  {userId ? `Loading phone numbers for user ${userId}...` : 'Validating user authentication...'}
                </div>
              </div>
              <div style={{ color: '#9ca3af', fontSize: '0.875rem', textAlign: 'center', maxWidth: '300px' }}>
                {userId ? 'Fetching your phone numbers and agent details...' : 'Please wait while we verify your authentication...'}
              </div>
            </div>
          ) : !userId ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '200px', gap: '16px' }}>
              <div style={{ color: '#dc2626', fontSize: '1.2rem' }}>
                <i className="fas fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                Authentication Required
              </div>
              <div style={{ color: '#6b7280', fontSize: '1rem', textAlign: 'center', maxWidth: '300px' }}>
                Please log in to access your phone numbers and manage your agents.
              </div>
            </div>
          ) : phoneNumbers.length === 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '200px', gap: '16px' }}>
              <div style={{ color: '#10b981', fontSize: '1.2rem' }}>
                <i className="fas fa-phone-plus" style={{ marginRight: '8px' }}></i>
                Ready to Add Phone Numbers
              </div>
              <div style={{ color: '#6b7280', fontSize: '1rem', textAlign: 'center', maxWidth: '300px' }}>
                You haven't added any phone numbers yet.<br />
                Click the <strong>+</strong> button above to add your first phone number.
              </div>
              <div style={{ 
                background: '#f0f9ff', 
                border: '1px solid #0ea5e9', 
                borderRadius: '8px', 
                padding: '12px 16px',
                maxWidth: '300px',
                textAlign: 'center'
              }}>
                <div style={{ color: '#0369a1', fontSize: '0.875rem', fontWeight: '500', marginBottom: '4px' }}>
                  💡 Getting Started
                </div>
                <div style={{ color: '#0c4a6e', fontSize: '0.75rem' }}>
                  Phone numbers are stored in the database and associated with your user account. 
                  Once added, you can configure agents and make calls.
                </div>
              </div>
            </div>
          ) : (
            phoneNumbers.map((num, idx) => (
              <div key={num.id} style={{ marginBottom: 16, borderRadius: 18, boxShadow: expanded.has(idx) ? '0 2px 12px rgba(0,0,0,0.07)' : 'none', background: expanded.has(idx) ? '#f8fafc' : '#fff', border: '1px solid #e5e7eb' }}>
                <div
                  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', cursor: 'pointer', borderRadius: 18 }}
                  onClick={() => handleAccordionClick(idx)}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <span style={{ fontWeight: 600, fontSize: '1.1rem', color: '#222' }}>
                      {num.name || num.nickname || num.phone_numbers || num.phoneNumber || 'Phone Number'}
                    </span>
                                         {num.connectionStatus === 'connected' && !num.alreadyExists && (
                       <span style={{ 
                         background: '#dcfce7', 
                         color: '#166534', 
                         padding: '4px 8px', 
                         borderRadius: '12px', 
                         fontSize: '0.75rem',
                         fontWeight: '500'
                       }}>
                         Connected
                       </span>
                     )}
                     {num.connectionStatus === 'connected' && num.alreadyExists && (
                       <span style={{ 
                         background: '#fef3c7', 
                         color: '#92400e', 
                         padding: '4px 8px', 
                         borderRadius: '12px', 
                         fontSize: '0.75rem',
                         fontWeight: '500'
                       }}>
                         Already Exists
                       </span>
                     )}
                    {num.connectionStatus === 'pending' && (
                      <span style={{ 
                        background: '#fef3c7', 
                        color: '#92400e', 
                        padding: '4px 8px', 
                        borderRadius: '12px', 
                        fontSize: '0.75rem',
                        fontWeight: '500'
                      }}>
                        Connecting...
                      </span>
                    )}
                  </div>
                  <span style={{ color: '#64748b', fontSize: 18 }}>
                    {expanded.has(idx) ? <i className="fas fa-chevron-up"></i> : <i className="fas fa-chevron-down"></i>}
                  </span>
                </div>
                                 {expanded.has(idx) && (
                   <div style={{ padding: '0 24px 18px 24px' }}>
                     <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
                       <div>
                         <span style={{ fontWeight: 500, fontSize: '1.1rem', marginRight: 12 }}>Phone Number:</span>
                         <span style={{ color: '#2563eb', fontWeight: 500 }}>{num.phoneNumber || num.id}</span>
                       </div>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button 
                          style={{ 
                            background: outboundCallLoading ? '#f3f4f6' : '#fff', 
                            color: outboundCallLoading ? '#9ca3af' : '#111827', 
                            border: '1px solid #e5e7eb', 
                            borderRadius: '8px', 
                            padding: '8px 18px', 
                            fontWeight: 500, 
                            fontSize: '1rem', 
                            cursor: outboundCallLoading ? 'not-allowed' : 'pointer', 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 8 
                          }}
                          onClick={() => !outboundCallLoading && handleOutboundCall(num.id)}
                          disabled={outboundCallLoading}
                        >
                          <i className={`fas ${outboundCallLoading ? 'fa-spinner fa-spin' : 'fa-phone'}`}></i> 
                          {outboundCallLoading ? 'Making call...' : 'Make an outbound call'}
                        </button>
                      </div>
                    </div>
                      <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '12px 0 18px 0' }} />
                     <div style={{ marginBottom: 12 }}>
                       <div style={{ fontWeight: 600, marginBottom: 8 }}>Inbound call agent</div>
                       <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                         <div style={{ color: '#374151', fontSize: '1rem' }}>{inboundAgents[idx] || 'Click "Change Agent" to assign'}</div>
                         <button 
                           style={{ background: '#fff', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '6px 12px', fontWeight: 500, fontSize: '0.8rem', cursor: 'pointer', flexShrink: 0 }}
                           onClick={() => handleChangeAgent(num, 'inbound')}
                         >
                           Change Agent
                         </button>
                         {/* Button to show phone numbers from agent_phone_connection table - COMMENTED OUT
                         {inboundAgents[idx] && inboundAgents[idx] !== 'Click "Change Agent" to assign' && (
                           <button 
                             style={{ background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', padding: '6px 12px', fontWeight: 500, fontSize: '0.8rem', cursor: 'pointer', flexShrink: 0 }}
                             onClick={async () => {
                               // const jsonData = await fetchInboundAgentPhoneNumbers(num.id);
                               // if (jsonData) {
                               //   setAgentPhoneNumbersJson(jsonData);
                               //   setShowPhoneNumbersJsonModal(true);
                               // }
                             }}
                             title="Show all phone numbers for this inbound agent from agent_phone_connection table"
                           >
                             📋 Show Agent Numbers
                           </button>
                         )}
                         */}

                       </div>
                     </div>
                     <div style={{ marginBottom: 12 }}>
                       <div style={{ fontWeight: 600, marginBottom: 8 }}>Outbound call agent</div>
                       <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                         <div style={{ color: '#374151', fontSize: '1rem' }}>{outboundAgents[idx] || 'Click "Change Agent" to assign'}</div>
                         <button 
                           style={{ background: '#fff', color: '#111827', border: '1px solid #e5e7eb', borderRadius: '8px', padding: '6px 12px', fontWeight: 500, fontSize: '0.8rem', cursor: 'pointer', flexShrink: 0 }}
                           onClick={() => handleChangeAgent(num, 'outbound')}
                         >
                           Change Agent
                         </button>
                       </div>
                     </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>
      
      {/* Modal for Add Phone Number */}
      {showModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            width: '500px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            overflowY: 'auto',
            position: 'relative'
          }}>
            {/* Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#111827'
              }}>
                Connect to your number via SIP trunking
              </h3>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit}>
              {/* Phone Number */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#111827',
                  fontSize: '0.875rem'
                }}>
                  Phone Number <span style={{ color: '#dc2626' }}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.phoneNumber}
                  onChange={(e) => handleInputChange('phoneNumber', e.target.value)}
                  placeholder="Enter phone number"
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Termination URI */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#111827',
                  fontSize: '0.875rem'
                }}>
                  Termination URI <span style={{ color: '#dc2626' }}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.terminationUri}
                  onChange={(e) => handleInputChange('terminationUri', e.target.value)}
                  placeholder="Enter termination URI (NOT Retell SIP server uri)"
                  required
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* SIP Trunk User Name */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#111827',
                  fontSize: '0.875rem'
                }}>
                  SIP Trunk User Name <span style={{ color: '#dc2626' }}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.sipTrunkUserName}
                  onChange={(e) => handleInputChange('sipTrunkUserName', e.target.value)}
                  placeholder="Enter SIP Trunk User Name"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* SIP Trunk Password */}
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#111827',
                  fontSize: '0.875rem'
                }}>
                  SIP Trunk Password <span style={{ color: '#dc2626' }}>*</span>
                </label>
                <input
                  type="password"
                  value={formData.sipTrunkPassword}
                  onChange={(e) => handleInputChange('sipTrunkPassword', e.target.value)}
                  placeholder="Enter SIP Trunk Password"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Nickname */}
              <div style={{ marginBottom: '24px' }}>
                <label style={{
                  display: 'block',
                  fontWeight: '600',
                  marginBottom: '8px',
                  color: '#111827',
                  fontSize: '0.875rem'
                }}>
                  Nickname <span style={{ color: '#dc2626' }}>*</span>
                </label>
                <input
                  type="text"
                  value={formData.nickname}
                  onChange={(e) => handleInputChange('nickname', e.target.value)}
                  placeholder="Enter Nickname"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '0.875rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              {/* Submit Button */}
              <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '12px'
              }}>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  disabled={submitting}
                  style={{
                    padding: '10px 20px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    background: '#fff',
                    color: '#374151',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: submitting ? 'not-allowed' : 'pointer',
                    opacity: submitting ? 0.6 : 1
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={submitting}
                  style={{
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '6px',
                    background: submitting ? '#9ca3af' : '#2563eb',
                    color: '#fff',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    cursor: submitting ? 'not-allowed' : 'pointer'
                  }}
                >
                  {submitting ? 'Connecting...' : 'Connect'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Agent Selection Modal */}
      {showAgentModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            width: '400px',
            maxWidth: '90vw',
            maxHeight: '90vh',
            overflowY: 'auto',
            position: 'relative'
          }}>
            {/* Header */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#111827',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                {agentSelectionLoading && (
                  <i className="fas fa-spinner fa-spin" style={{ fontSize: '1rem', color: '#3b82f6' }}></i>
                )}
                {agentSelectionLoading && selectedAgentForUpdate ? (
                  `Updating ${agentType === 'inbound' ? 'Inbound' : 'Outbound'} Agent: ${selectedAgentForUpdate}...`
                ) : (
                  `Select ${agentType === 'inbound' ? 'Inbound' : 'Outbound'} Agent`
                )}
              </h3>
              <button
                onClick={() => {
                  if (!agentSelectionLoading) {
                    setShowAgentModal(false);
                    setSelectedPhoneNumber(null);
                    setAgentType('');
                  }
                }}
                disabled={agentSelectionLoading}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: agentSelectionLoading ? 'not-allowed' : 'pointer',
                  color: agentSelectionLoading ? '#d1d5db' : '#6b7280',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            {/* Agent List */}
            <div style={{ marginBottom: '24px' }}>
              {availableAgents.length > 0 ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {availableAgents.map((agent, index) => {
                    const isThisAgentUpdating = agentSelectionLoading && selectedAgentForUpdate === agent.agent_name;
                    return (
                      <button
                        key={index}
                        onClick={() => !agentSelectionLoading && handleAgentSelection(agent.agent_name)}
                        disabled={agentSelectionLoading}
                        style={{
                          padding: '12px 16px',
                          border: '1px solid #e5e7eb',
                          borderRadius: '8px',
                          background: isThisAgentUpdating ? '#f3f4f6' : '#fff',
                          color: isThisAgentUpdating ? '#9ca3af' : '#111827',
                          fontSize: '0.875rem',
                          fontWeight: '500',
                          cursor: agentSelectionLoading ? 'not-allowed' : 'pointer',
                          textAlign: 'left',
                          transition: 'all 0.2s',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}
                        onMouseOver={(e) => {
                          if (!agentSelectionLoading) {
                            e.target.style.background = '#f9fafb';
                            e.target.style.borderColor = '#d1d5db';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (!agentSelectionLoading) {
                            e.target.style.background = '#fff';
                            e.target.style.borderColor = '#e5e7eb';
                          }
                        }}
                      >
                        {isThisAgentUpdating && (
                          <i className="fas fa-spinner fa-spin" style={{ fontSize: '0.75rem' }}></i>
                        )}
                        {agent.agent_name}
                        {isThisAgentUpdating && (
                          <span style={{ fontSize: '0.75rem', color: '#6b7280', marginLeft: 'auto' }}>
                            Updating...
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  color: '#6b7280', 
                  padding: '20px',
                  fontSize: '0.875rem'
                }}>
                  No agents available. Please create an agent first.
                </div>
              )}
            </div>

            {/* Cancel Button */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => {
                  setShowAgentModal(false);
                  setSelectedPhoneNumber(null);
                  setAgentType('');
                }}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  background: '#fff',
                  color: '#374151',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Phone Numbers JSON Modal - COMMENTED OUT 
      {false && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#fff',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '800px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#111827'
              }}>
                🔧 Update Agent LLM with Transfer Call Functionality
              </h3>
              <button
                onClick={() => {}}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#6b7280',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <p style={{
                margin: '0 0 16px 0',
                color: '#6b7280',
                fontSize: '0.875rem',
                lineHeight: '1.5'
              }}>
                Found 0 phone numbers for agent ID: null
              </p>
              <p style={{
                margin: '0 0 16px 0',
                color: '#059669',
                fontSize: '0.875rem',
                lineHeight: '1.5',
                fontWeight: '500'
              }}>
                💡 This will update the agent's LLM model to automatically transfer calls from these phone numbers to the specified transfer number without any AI interaction.
              </p>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#111827'
              }}>
                Phone Numbers Data (JSON Format):
              </label>
              <pre style={{
                background: '#f8fafc',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                padding: '16px',
                fontSize: '0.75rem',
                overflowX: 'auto',
                maxHeight: '300px',
                overflowY: 'auto'
              }}>
                {JSON.stringify({}, null, 2)}
              </pre>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#111827'
              }}>
                🔄 Transfer To Phone Number (Human Assistant):
              </label>
              <input
                type="tel"
                value={transferToNumber}
                onChange={(e) => setTransferToNumber(e.target.value)}
                placeholder="+1234567890"
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '0.875rem',
                  color: '#111827',
                  backgroundColor: '#fff'
                }}
              />
              <p style={{
                margin: '4px 0 0 0',
                fontSize: '0.75rem',
                color: '#6b7280',
                fontStyle: 'italic'
              }}>
                Enter the phone number where calls will be automatically transferred when someone calls the agent's phone numbers (must include country code, e.g., +61405107303)
              </p>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px'
            }}>
              <button
                onClick={() => {}}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  background: '#fff',
                  color: '#374151',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
              <button
                onClick={() => setShowTransferCallModal(true)}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: '#10b981',
                  color: '#fff',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                🔧 Configure Transfer Call Tool
              </button>
              <button
                onClick={async () => {
                  if (!transferToNumber) {
                    setError('❌ Please enter a transfer phone number');
                    return;
                  }
                  
                  const result = await updateAgentLLMWithTransferCall(
                    null,
                    [],
                    transferToNumber
                  );
                  
                  if (result) {
                    // setShowPhoneNumbersJsonModal(false);
                    setTransferToNumber('');
                  }
                }}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: '#dc2626',
                  color: '#fff',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                🚨 Update Agent LLM with Transfer Call
              </button>
            </div>
          </div>
        </div>
      )}
      */}

      {/* Transfer Call Configuration Modal */}
      {showTransferCallModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#1f2937',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#f9fafb'
              }}>
                🔧 Transfer Call Tool Configuration
              </h3>
              <button
                onClick={() => setShowTransferCallModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#9ca3af',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            {/* Tool Name */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#f9fafb'
              }}>
                Tool Name
              </label>
              <input
                type="text"
                value={transferCallConfig.name}
                onChange={(e) => setTransferCallConfig(prev => ({ ...prev, name: e.target.value }))}
                placeholder="transfer_call"
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  background: '#374151',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  color: '#f9fafb',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                onBlur={(e) => e.target.style.borderColor = '#4b5563'}
              />
            </div>

            {/* Tool Description */}
            <div style={{ marginBottom: '24px' }}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#f9fafb'
              }}>
                Tool Description
              </label>
              <textarea
                value={transferCallConfig.description}
                onChange={(e) => setTransferCallConfig(prev => ({ ...prev, description: e.target.value }))}
                placeholder="Transfer the call to a human agent."
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  background: '#374151',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  color: '#f9fafb',
                  fontSize: '14px',
                  outline: 'none',
                  resize: 'vertical',
                  minHeight: '80px',
                  fontFamily: 'inherit',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                onBlur={(e) => e.target.style.borderColor = '#4b5563'}
              />
            </div>

            {/* Transfer to Section */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                color: '#f9fafb',
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: '12px'
              }}>
                Transfer to
              </h3>
              <div style={{
                display: 'flex',
                gap: '8px',
                marginBottom: '12px'
              }}>
                <button
                  type="button"
                  onClick={() => setTransferCallConfig(prev => ({ ...prev, transfer_to: 'static' }))}
                  style={{
                    padding: '8px 16px',
                    background: transferCallConfig.transfer_to === 'static' ? '#3b82f6' : '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  Static Destination
                </button>
                <button
                  type="button"
                  onClick={() => setTransferCallConfig(prev => ({ ...prev, transfer_to: 'dynamic' }))}
                  style={{
                    padding: '8px 16px',
                    background: transferCallConfig.transfer_to === 'dynamic' ? '#3b82f6' : '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s ease'
                  }}
                >
                  Dynamic Routing
                </button>
              </div>
              <input
                type="text"
                value={transferCallConfig.destination_number}
                onChange={(e) => setTransferCallConfig(prev => ({ ...prev, destination_number: e.target.value }))}
                placeholder="+18563630633"
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  background: '#374151',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  color: '#f9fafb',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                onBlur={(e) => e.target.style.borderColor = '#4b5563'}
              />
              <p style={{
                color: '#9ca3af',
                fontSize: '12px',
                marginTop: '4px',
                marginBottom: '0'
              }}>
                Enter a static phone number / SIP URI / dynamic variable.
              </p>
            </div>

            {/* Type Section */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                color: '#f9fafb',
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: '12px'
              }}>
                Type
              </h3>
              <div style={{ marginBottom: '8px' }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#f9fafb',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>
                  <input
                    type="radio"
                    name="transfer_type"
                    value="cold"
                    checked={transferCallConfig.transfer_type === 'cold'}
                    onChange={(e) => setTransferCallConfig(prev => ({ ...prev, transfer_type: e.target.value }))}
                    style={{
                      marginRight: '8px',
                      width: '16px',
                      height: '16px'
                    }}
                  />
                  Cold Transfer
                  <i className="fas fa-info-circle" style={{
                    marginLeft: '8px',
                    color: '#6b7280',
                    fontSize: '14px'
                  }}></i>
                </label>
              </div>
              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#f9fafb',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>
                  <input
                    type="radio"
                    name="transfer_type"
                    value="warm"
                    checked={transferCallConfig.transfer_type === 'warm'}
                    onChange={(e) => setTransferCallConfig(prev => ({ ...prev, transfer_type: e.target.value }))}
                    style={{
                      marginRight: '8px',
                      width: '16px',
                      height: '16px'
                    }}
                  />
                  Warm Transfer
                  <i className="fas fa-info-circle" style={{
                    marginLeft: '8px',
                    color: '#6b7280',
                    fontSize: '14px'
                  }}></i>
                </label>
              </div>
            </div>

            {/* Displayed Phone Number Section */}
            <div style={{ marginBottom: '24px' }}>
              <h3 style={{
                color: '#f9fafb',
                fontSize: '16px',
                fontWeight: '600',
                marginBottom: '12px'
              }}>
                Displayed Phone Number
              </h3>
              <div style={{ marginBottom: '8px' }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#f9fafb',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>
                  <input
                    type="radio"
                    name="displayed_phone_number"
                    value="retell_agent"
                    checked={transferCallConfig.displayed_phone_number === 'retell_agent'}
                    onChange={(e) => setTransferCallConfig(prev => ({ ...prev, displayed_phone_number: e.target.value }))}
                    style={{
                      marginRight: '8px',
                      width: '16px',
                      height: '16px'
                    }}
                  />
                  Retell Agent
                </label>
              </div>
              <div>
                <label style={{
                  display: 'flex',
                  alignItems: 'center',
                  color: '#f9fafb',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>
                  <input
                    type="radio"
                    name="displayed_phone_number"
                    value="transferee"
                    checked={transferCallConfig.displayed_phone_number === 'transferee'}
                    onChange={(e) => setTransferCallConfig(prev => ({ ...prev, displayed_phone_number: e.target.value }))}
                    style={{
                      marginRight: '8px',
                      width: '16px',
                      height: '16px'
                    }}
                  />
                  Transferee
                </label>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px'
            }}>
              <button
                onClick={() => setShowTransferCallModal(false)}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  background: '#374151',
                  color: '#f9fafb',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleTransferCallConfig}
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: '#10b981',
                  color: '#fff',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1
                }}
              >
                {loading ? '🔄 Configuring...' : '✅ Configure Transfer Call'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Transfer Call Result Display Modal */}
      {showTransferResult && transferCallResult && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#1f2937',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#f9fafb'
              }}>
                ✅ Transfer Call Tool Added Successfully
              </h3>
              <button
                onClick={() => setShowTransferResult(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#9ca3af',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <p style={{
                margin: '0 0 16px 0',
                color: '#d1d5db',
                fontSize: '0.875rem',
                lineHeight: '1.5'
              }}>
                Transfer Call tool has been successfully added to the LLM configuration
              </p>
            </div>

            {/* Transfer Call Details */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{
                background: '#374151',
                borderRadius: '8px',
                padding: '16px'
              }}>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Tool Name:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{transferCallResult.tool_name}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Destination Number:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{transferCallResult.destination_number}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Transfer Type:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{transferCallResult.transfer_type}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Transfer To:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{transferCallResult.transfer_to}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Displayed Phone Number:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{transferCallResult.displayed_phone_number}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Timestamp:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{new Date(transferCallResult.timestamp).toLocaleString()}</span>
                </div>
              </div>
            </div>

            {/* Backend Result */}
            {transferCallResult.backend_result && (
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  color: '#f9fafb',
                  fontSize: '1rem',
                  fontWeight: '600',
                  marginBottom: '12px'
                }}>
                  Backend Response
                </h4>
                <pre style={{
                  background: '#374151',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  padding: '16px',
                  fontSize: '0.75rem',
                  overflowX: 'auto',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  color: '#d1d5db'
                }}>
                  {JSON.stringify(transferCallResult.backend_result, null, 2)}
                </pre>
              </div>
            )}

            {/* Action Button */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowTransferResult(false)}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: '#10b981',
                  color: '#fff',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Webhook Configuration Modal */}
      {showWebhookModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#1f2937',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '700px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#f9fafb'
              }}>
                🔗 Frontend Webhook Logic Implementation for {selectedPhoneForWebhook?.phone_number}
              </h3>
              <button
                onClick={() => setShowWebhookModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#9ca3af',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            {/* Configuration Form */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{
                color: '#f9fafb',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🔑 Frontend Webhook Logic Configuration
              </h4>

            {/* Agent ID - Populated from CAPTURED JSON data */}
            <div style={{ marginBottom: '16px' }}>

              <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '0.875rem',
                fontWeight: '500',
                color: '#f9fafb'
              }}>
                Agent ID * (from captured JSON data)
              </label>
              <input
                type="text"
                value={webhookConfig.agent_id}
                onChange={(e) => setWebhookConfig(prev => ({ ...prev, agent_id: e.target.value }))}
                placeholder="agent_..."
                style={{
                  width: '100%',
                  padding: '10px 12px',
                  background: '#374151',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  color: '#f9fafb',
                  fontSize: '14px',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                onBlur={(e) => e.target.style.borderColor = '#4b5563'}
              />
              {/* Debug info */}
              <p style={{
                color: '#9ca3af',
                fontSize: '12px',
                marginTop: '4px',
                marginBottom: '0'
              }}>
                Current value: {webhookConfig.agent_id || 'empty'}
              </p>
            </div>

              {/* User Phone Number for Transfer */}
              <div style={{ marginBottom: '16px' }}>

                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#f9fafb'
                }}>
                  Transfer To Phone Number (from captured JSON data)
                </label>
                <input
                  type="text"
                  value={webhookConfig.user_phone_number}
                  onChange={(e) => setWebhookConfig(prev => ({ ...prev, user_phone_number: e.target.value }))}
                  placeholder="+61405107303"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
                <p style={{
                  color: '#9ca3af',
                  fontSize: '12px',
                  marginTop: '4px',
                  marginBottom: '0'
                }}>
                  Phone number to transfer verified calls to
                </p>
              </div>
            </div>

            {/* Twilio Configuration */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{
                color: '#f9fafb',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                📞 Twilio Configuration
              </h4>
              

              






              {/* Notification Phone */}
              <div style={{ marginBottom: '16px' }}>

                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#f9fafb'
                }}>
                  Notification Phone Number
                </label>
                <input
                  type="text"
                  value={webhookConfig.notification_phone}
                  onChange={(e) => setWebhookConfig(prev => ({ ...prev, notification_phone: e.target.value }))}
                  placeholder="+61405107303"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
                <p style={{
                  color: '#9ca3af',
                  fontSize: '12px',
                  marginTop: '4px',
                  marginBottom: '0'
                }}>
                  Your phone number to receive SMS notifications
                </p>
              </div>
            </div>

            {/* Webhook URLs */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{
                color: '#f9fafb',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🌐 Webhook URLs
              </h4>
              
              {/* Main Webhook URL */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#f9fafb'
                }}>
                  Main Webhook URL
                </label>
                <input
                  type="url"
                  value={webhookConfig.webhook_url}
                  onChange={(e) => setWebhookConfig(prev => ({ ...prev, webhook_url: e.target.value }))}
                  placeholder="https://your-domain.com/webhook"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
                <p style={{
                  color: '#9ca3af',
                  fontSize: '12px',
                  marginTop: '4px',
                  marginBottom: '0'
                }}>
                  Set this as Voice URL in Twilio for {selectedPhoneForWebhook?.phone_number}
                </p>
              </div>

              {/* Post-Call Webhook URL */}
              <div style={{ marginBottom: '16px' }}>
                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#f9fafb'
                }}>
                  Post-Call Webhook URL
                </label>
                <input
                  type="url"
                  value={webhookConfig.post_call_webhook_url}
                  onChange={(e) => setWebhookConfig(prev => ({ ...prev, post_call_webhook_url: e.target.value }))}
                  placeholder="https://your-domain.com/post_call"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
                <p style={{
                  color: '#9ca3af',
                  fontSize: '12px',
                  marginTop: '4px',
                  marginBottom: '0'
                }}>
                  Set this as post-call webhook in Retell for call analysis
                </p>
              </div>
            </div>

            {/* Verification List */}
            <div style={{ marginBottom: '24px' }}>
              <h4 style={{
                color: '#f9fafb',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                ✅ Verified Numbers
              </h4>
              
              <div style={{ marginBottom: '16px' }}>

                <label style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  color: '#f9fafb'
                }}>
                  Verified Phone Numbers (one per line) - Populated from captured JSON data
                </label>
                <textarea
                  value={webhookConfig.verification_list.join('\n')}
                  onChange={(e) => setWebhookConfig(prev => ({ 
                    ...prev, 
                    verification_list: e.target.value.split('\n').filter(num => num.trim()) 
                  }))}
                  placeholder="+61405107303&#10;+1234567890"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    background: '#374151',
                    border: '1px solid #4b5563',
                    borderRadius: '6px',
                    color: '#f9fafb',
                    fontSize: '14px',
                    outline: 'none',
                    resize: 'vertical',
                    minHeight: '80px',
                    fontFamily: 'inherit',
                    transition: 'border-color 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
                  onBlur={(e) => e.target.style.borderColor = '#4b5563'}
                />
                <p style={{
                  color: '#9ca3af',
                  fontSize: '12px',
                  marginTop: '4px',
                  marginBottom: '0'
                }}>
                  Calls from these numbers will be immediately transferred
                </p>
              </div>
            </div>

            {/* JSON Data Display - COMMENTED OUT - Show Agent Numbers functionality removed */}

            {/* Flask Script Environment Variables */}
            <div style={{
              background: '#1e3a8a',
              border: '1px solid #3b82f6',
              borderRadius: '6px',
              padding: '16px',
              marginBottom: '24px'
            }}>
              <h4 style={{
                color: '#dbeafe',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🐍 Flask Script Environment Variables
              </h4>
              <div style={{
                background: '#0f172a',
                border: '1px solid #1e40af',
                borderRadius: '6px',
                padding: '12px',
                marginBottom: '12px',
                fontFamily: 'monospace',
                fontSize: '11px'
              }}>
                <div style={{ color: '#60a5fa', marginBottom: '8px' }}># .env file for Flask webhook script:</div>
                <div style={{ color: '#fbbf24' }}>AGENT_ID={webhookConfig.agent_id || 'your_agent_id'}</div>
                <div style={{ color: '#fbbf24' }}>USER_PHONE_NUMBER={webhookConfig.user_phone_number || 'your_transfer_number'}</div>
                <div style={{ color: '#fbbf24' }}>NOTIFICATION_PHONE={webhookConfig.notification_phone || 'your_notification_number'}</div>
                <div style={{ color: '#fbbf24' }}>TWILIO_ACCOUNT_SID=your_twilio_account_sid</div>
                <div style={{ color: '#fbbf24' }}>TWILIO_AUTH_TOKEN=your_twilio_auth_token</div>
                <div style={{ color: '#fbbf24' }}>TWILIO_PHONE_NUMBER=your_twilio_number</div>
                <div style={{ color: '#fbbf24' }}>RETELL_API_KEY=your_retell_api_key</div>
              </div>
              <p style={{
                color: '#93c5fd',
                fontSize: '11px',
                marginTop: '8px',
                marginBottom: '0'
              }}>
                These environment variables will be used by the Flask webhook script to handle calls
              </p>
            </div>

            {/* Flask Script Integration */}
            <div style={{
              background: '#581c87',
              border: '1px solid #8b5cf6',
              borderRadius: '6px',
              padding: '16px',
              marginBottom: '24px'
            }}>
              <h4 style={{
                color: '#e9d5ff',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🔗 Flask Webhook Script Integration
              </h4>
              <div style={{
                background: '#0f172a',
                border: '1px solid #7c3aed',
                borderRadius: '6px',
                padding: '12px',
                marginBottom: '12px',
                fontFamily: 'monospace',
                fontSize: '11px',
                maxHeight: '200px',
                overflowY: 'auto'
              }}>
                <div style={{ color: '#60a5fa', marginBottom: '8px' }}># Flask script endpoints that will be created:</div>
                <div style={{ color: '#fbbf24' }}>POST / - Main webhook for Retell inbound calls</div>
                <div style={{ color: '#fbbf24' }}>POST /post_call - Post-call analysis webhook</div>
                <div style={{ color: '#fbbf24' }}>GET / - Health check endpoint</div>
                <div style={{ color: '#a78bfa', marginTop: '8px' }}>
                  # Verification list will be created from: {webhookConfig.verification_list.length} numbers
                </div>
                <div style={{ color: '#a78bfa' }}>
                  # Agent ID: {webhookConfig.agent_id || 'Not set'}
                </div>
                <div style={{ color: '#a78bfa' }}>
                  # Transfer number: {webhookConfig.user_phone_number || 'Not set'}
                </div>
              </div>
              <p style={{
                color: '#c4b5fd',
                fontSize: '11px',
                marginTop: '8px',
                marginBottom: '0'
              }}>
                The Flask script will automatically handle call routing based on verified numbers
              </p>
            </div>

            {/* Deployment Instructions */}
            <div style={{
              background: '#065f46',
              border: '1px solid #10b981',
              borderRadius: '6px',
              padding: '16px',
              marginBottom: '24px'
            }}>
              <h4 style={{
                color: '#d1fae5',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🚀 Deployment Instructions
              </h4>
              <div style={{
                background: '#0f172a',
                border: '1px solid #059669',
                borderRadius: '6px',
                padding: '12px',
                marginBottom: '12px',
                fontFamily: 'monospace',
                fontSize: '11px'
              }}>
                <div style={{ color: '#fbbf24' }}># 1. Install dependencies:</div>
                <div style={{ color: '#60a5fa' }}>pip install flask twilio phonenumbers python-dotenv</div>
                <div style={{ color: '#fbbf24', marginTop: '8px' }}># 2. Create .env file with variables above</div>
                <div style={{ color: '#fbbf24', marginTop: '8px' }}># 3. Run locally:</div>
                <div style={{ color: '#60a5fa' }}>python check_caller_number.py</div>
                <div style={{ color: '#fbbf24', marginTop: '8px' }}># 4. For production, deploy to Heroku/AWS</div>
                <div style={{ color: '#fbbf24', marginTop: '8px' }}># 5. Set webhook URLs in Retell dashboard</div>
              </div>
              <p style={{
                color: '#a7f3d0',
                fontSize: '11px',
                marginTop: '8px',
                marginBottom: '0'
              }}>
                Follow these steps to deploy your Flask webhook server
              </p>
            </div>

            {/* Python Flask Script Template */}
            <div style={{
              background: '#7c2d12',
              border: '1px solid #ea580c',
              borderRadius: '6px',
              padding: '16px',
              marginBottom: '24px'
            }}>
              <h4 style={{
                color: '#fed7aa',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🐍 Python Flask Script Template
              </h4>
              <div style={{
                background: '#0f172a',
                border: '1px solid #ea580c',
                borderRadius: '6px',
                padding: '12px',
                marginBottom: '12px',
                fontFamily: 'monospace',
                fontSize: '10px',
                maxHeight: '300px',
                overflowY: 'auto',
                color: '#fbbf24'
              }}>
                <div style={{ color: '#60a5fa' }}># check_caller_number.py</div>
                <div style={{ color: '#60a5fa' }}>import os, json, logging, phonenumbers</div>
                <div style={{ color: '#60a5fa' }}>from flask import Flask, request, jsonify</div>
                <div style={{ color: '#60a5fa' }}>from dotenv import load_dotenv</div>
                <div style={{ color: '#60a5fa' }}>from twilio.rest import Client</div>
                <div style={{ color: '#60a5fa', marginTop: '8px' }}>load_dotenv()</div>
                <div style={{ color: '#60a5fa', marginTop: '8px' }}>app = Flask(__name__)</div>
                <div style={{ color: '#fbbf24', marginTop: '8px' }}># Your config from above:</div>
                <div style={{ color: '#a78bfa' }}>AGENT_ID = "{webhookConfig.agent_id || 'your_agent_id'}"</div>
                <div style={{ color: '#a78bfa' }}>USER_PHONE_NUMBER = "{webhookConfig.user_phone_number || 'your_transfer_number'}"</div>
                <div style={{ color: '#a78bfa' }}>NOTIFICATION_PHONE = "{webhookConfig.notification_phone || 'your_notification_number'}"</div>
                <div style={{ color: '#fbbf24', marginTop: '8px' }}># Verification list from above:</div>
                <div style={{ color: '#a78bfa' }}>VERIFIED_NUMBERS = {JSON.stringify(webhookConfig.verification_list.length > 0 ? webhookConfig.verification_list : ['+61405107303'], null, 2)}</div>
                <div style={{ color: '#60a5fa', marginTop: '8px' }}># Set as Voice URL in Twilio: {webhookConfig.webhook_url || 'https://your-domain.com/'}</div>
                <div style={{ color: '#60a5fa' }}># Set as post-call webhook in Retell: {webhookConfig.post_call_webhook_url || 'https://your-domain.com/post_call'}</div>
              </div>
              <p style={{
                color: '#fbbf24',
                fontSize: '11px',
                marginTop: '8px',
                marginBottom: '0'
              }}>
                This template shows how your configuration maps to the Flask script
              </p>
            </div>

            {/* Debug: Current Webhook Configuration Values */}
            <div style={{
              background: '#1e3a8a',
              border: '1px solid #3b82f6',
              borderRadius: '6px',
              padding: '16px',
              marginBottom: '24px'
            }}>
              <h4 style={{
                color: '#dbeafe',
                fontSize: '1rem',
                fontWeight: '600',
                marginBottom: '16px'
              }}>
                🔍 DEBUG: Current Webhook Configuration Values
              </h4>
              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '12px',
                fontSize: '12px'
              }}>
                <div>
                  <span style={{ color: '#9ca3af' }}>Agent ID:</span>
                  <span style={{ color: '#f9fafb', marginLeft: '8px', fontFamily: 'monospace' }}>
                    {webhookConfig.agent_id || 'Not set'}
                  </span>
                </div>
                <div>
                  <span style={{ color: '#9ca3af' }}>Transfer To:</span>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>
                    {webhookConfig.user_phone_number || 'Not set'}
                  </span>
                </div>
                <div>
                  <span style={{ color: '#9ca3af' }}>Notification Phone:</span>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>
                    {webhookConfig.notification_phone || 'Not set'}
                  </span>
                </div>
                <div>
                  <span style={{ color: '#9ca3af' }}>Verification List:</span>
                  <span style={{ color: '#fbbf24', marginLeft: '8px' }}>
                    {webhookConfig.verification_list.length} numbers
                  </span>
                </div>
              </div>
              <p style={{
                color: '#93c5fd',
                fontSize: '11px',
                marginTop: '8px',
                marginBottom: '0'
              }}>
                These values are automatically populated from the captured JSON data above
              </p>
            </div>

            {/* Action Buttons */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '12px'
            }}>
              <button
                onClick={() => {
                  setShowWebhookModal(false);
                  // Reset webhook config when closing modal
                  setWebhookConfig({
                    user_phone_number: '',
                    agent_id: '',
                    notification_phone: '',
                    verification_list: [],
                    webhook_url: '',
                    post_call_webhook_url: ''
                  });
                }}
                style={{
                  padding: '10px 20px',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  background: '#374151',
                  color: '#f9fafb',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleWebhookConfig}
                disabled={loading}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: '#8b5cf6',
                  color: '#fff',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.6 : 1
                }}
              >
                {loading ? '🔄 Implementing...' : '✅ Implement Webhook Logic'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Webhook Result Display Modal */}
      {showWebhookResult && webhookResult && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: '#1f2937',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '600px',
            width: '90%',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '24px'
            }}>
              <h3 style={{
                margin: 0,
                fontSize: '1.25rem',
                fontWeight: '600',
                color: '#f9fafb'
              }}>
                ✅ Webhook Successfully Configured
              </h3>
              <button
                onClick={() => setShowWebhookResult(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '1.5rem',
                  cursor: 'pointer',
                  color: '#9ca3af',
                  padding: '4px'
                }}
              >
                ×
              </button>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <p style={{
                margin: '0 0 16px 0',
                color: '#d1d5db',
                fontSize: '0.875rem',
                lineHeight: '1.5'
              }}>
                Webhook has been successfully configured for the phone number
              </p>
            </div>

            {/* Webhook Configuration Details */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{
                background: '#374151',
                borderRadius: '8px',
                padding: '16px'
              }}>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Twilio Phone Number:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{webhookResult.twilio_phone_number}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Agent ID:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{webhookResult.agent_id || 'Auto-populated'}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Webhook URL:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{webhookResult.webhook_url}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Post-Call Webhook:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{webhookResult.post_call_webhook_url}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Verified Numbers:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{webhookResult.verification_list.join(', ')}</span>
                </div>
                <div style={{ marginBottom: '12px' }}>
                  <strong style={{ color: '#f9fafb' }}>Timestamp:</strong>
                  <span style={{ color: '#f9fafb', marginLeft: '8px' }}>{new Date(webhookResult.timestamp).toLocaleString()}</span>
                </div>
              </div>
            </div>

            {/* Backend Result */}
            {webhookResult.backend_result && (
              <div style={{ marginBottom: '24px' }}>
                <h4 style={{
                  color: '#f9fafb',
                  fontSize: '1rem',
                  fontWeight: '600',
                  marginBottom: '12px'
                }}>
                  Backend Response
                </h4>
                <pre style={{
                  background: '#374151',
                  border: '1px solid #4b5563',
                  borderRadius: '6px',
                  padding: '16px',
                  fontSize: '0.75rem',
                  overflowX: 'auto',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  color: '#d1d5db'
                }}>
                  {JSON.stringify(webhookResult.backend_result, null, 2)}
                </pre>
              </div>
            )}

            {/* Action Button */}
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
              <button
                onClick={() => setShowWebhookResult(false)}
                style={{
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '6px',
                  background: '#8b5cf6',
                  color: '#fff',
                  fontSize: '0.875rem',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}




      </div>
    </>
  );
};

export default PhoneNumbers; 